/* tslint:disable */
/* eslint-disable */
/**
 * Proxima APIs
 * Api guide
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AdPixelInnerStatusEnum = {
    Active: 'active',
    Deleted: 'deleted'
};
export const AdsBoardOwnerTypeEnum = {
    BRAND: 'brand',
    USER: 'user'
};
export const AdsBoardOwnerTypeOwnerTypeEnum = {
    BRAND: 'brand',
    USER: 'user'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BillingStatus = {
    Incomplete: 'incomplete',
    IncompleteExpired: 'incomplete_expired',
    Trialing: 'trialing',
    Active: 'active',
    PastDue: 'past_due',
    Canceled: 'canceled',
    Unpaid: 'unpaid',
    Paused: 'paused'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BillingStatus1 = {
    Trial: 'TRIAL',
    Active: 'ACTIVE',
    Grace: 'GRACE',
    Cancelled: 'CANCELLED',
    PastDue: 'PAST_DUE'
};
export const BrandStatusEnum = {
    Active: 'active',
    Deleted: 'deleted',
    Locked: 'locked'
};
export const BrandHistoryItemStatusEnum = {
    Active: 'active',
    Deleted: 'deleted',
    Locked: 'locked'
};
export const BrandLockRequestAudienceOptionEnum = {
    KeepAudiences: 'keep_audiences',
    RemoveAudiences: 'remove_audiences'
};
export const CreateAdBoardInputOwnerTypeEnum = {
    BRAND: 'brand',
    USER: 'user'
};
export const CreateAdHocSeedAudienceRequestSeedAudienceTypeEnum = {
    AdHoc: 'adHoc'
};
export const CreateAdHocSeedAudienceRequestIntegrationsInnerIntegrationTypeEnum = {
    Facebook: 'facebook',
    Tiktok: 'tiktok'
};
export const CreateIntegrationRequestTypeEnum = {
    Shopify: 'shopify',
    Facebook: 'facebook'
};
export const CreateLookalikeAudienceRequestIntegrationTypeEnum = {
    Facebook: 'facebook',
    Tiktok: 'tiktok'
};
export const CreateSeedAudienceRequestIntegrationsInnerIntegrationTypeEnum = {
    Facebook: 'facebook'
};
export const EntitlementsProximaAuthEnum = {
    Readaccess: 'read:access',
    Updateaccess: 'update:access',
    Deleteaccess: 'delete:access'
};
export const EntitlementsProximaBrandsEnum = {
    Readbrand: 'read:brand',
    Writebrand: 'write:brand'
};
export const EntitlementsProximaIntegrationsEnum = {
    ReadsyncState: 'read:syncState',
    UpdatesyncState: 'update:syncState',
    Readintegration: 'read:integration',
    Decrypttoken: 'decrypt:token'
};
export const EntitlementsProximaIntegrationsScheduleEnum = {
    Readsyncs: 'read:syncs',
    Schedulesyncs: 'schedule:syncs'
};
export const EntitlementsProximaUsersEnum = {
    Readprofile: 'read:profile',
    Writeprofile: 'write:profile'
};
export const GetAdsBoardResponseOwnerTypeEnum = {
    BRAND: 'brand',
    USER: 'user'
};
export const GetIntegrationsByBrandResponseInnerTypeEnum = {
    Shopify: 'shopify',
    Facebook: 'facebook',
    Tiktok: 'tiktok',
    Klaviyo: 'klaviyo'
};
export const GetIntegrationsByBrandResponseInnerStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    Unauthorized: 'unauthorized',
    Deleted: 'deleted'
};
export const IntegrationResponseTypeEnum = {
    Shopify: 'shopify',
    Facebook: 'facebook',
    Tiktok: 'tiktok',
    Klaviyo: 'klaviyo'
};
export const IntegrationResponseStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    Unauthorized: 'unauthorized',
    Deleted: 'deleted'
};
export const LookalikeAudienceIntegrationTypeEnum = {
    Facebook: 'facebook',
    Tiktok: 'tiktok'
};
export const LookalikeAudienceStatusEnum = {
    Processing: 'Processing',
    Delivered: 'Delivered',
    Error: 'Error',
    Active: 'Active',
    Inactive: 'Inactive',
    Deleted: 'Deleted'
};
export const LookalikeAudienceSizesInnerIntegrationTypeEnum = {
    Facebook: 'facebook',
    Tiktok: 'tiktok'
};
export const SeedAudienceTypeEnum = {
    SelfService: 'selfService',
    EnhancedLookalike: 'enhancedLookalike',
    BuildYourOwn: 'buildYourOwn',
    AdHoc: 'adHoc'
};
export const SeedAudienceStatusEnum = {
    New: 'new',
    Generating: 'generating',
    Delivered: 'delivered',
    Error: 'error'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SeedAudienceType = {
    SelfService: 'selfService',
    EnhancedLookalike: 'enhancedLookalike',
    BuildYourOwn: 'buildYourOwn',
    BrandOverlap: 'brandOverlap'
};
export const SubscriptionStatusEnum = {
    Incomplete: 'incomplete',
    IncompleteExpired: 'incomplete_expired',
    Trialing: 'trialing',
    Active: 'active',
    PastDue: 'past_due',
    Canceled: 'canceled',
    Unpaid: 'unpaid'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionPlan = {
    MonthByMonth: 'EVERY_30_DAYS',
    Annual: 'ANNUAL'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionStatus = {
    Created: 'CREATED',
    Pending: 'PENDING',
    Confirming: 'CONFIRMING',
    TrialActive: 'TRIAL_ACTIVE',
    Active: 'ACTIVE',
    CancelPending: 'CANCEL_PENDING',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    Frozen: 'FROZEN',
    Declined: 'DECLINED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SubscriptionType = {
    Yearly: 'yearly',
    Monthtly: 'monthly',
    Pro: 'pro',
    FreeTrial: 'freeTrial'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SyncStatus = {
    Error: 'error',
    Success: 'success',
    ApiLimitReached: 'api-limit-reached',
    ExpiredToken: 'expired-token',
    MissingPermissions: 'missing-permissions'
};
export const UpdateSubscriptionInputSubscriptionTypeEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
};
export const UploadCustomerBatchStatusRequestUploadStatusEnum = {
    Uploaded: 'uploaded',
    Failed: 'failed'
};
/**
 * AudienceSpendApi - axios parameter creator
 * @export
 */
export const AudienceSpendApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get spend data for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} [startDate] start date in UTC to filter spend
         * @param {string} [endDate] end date in UTC to filter spend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSpend: (brandId, startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandSpend', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/audience/spend`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substring(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substring(0, 10) :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get spend data from brand that has monthly average spend and lifetime spend
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSpendSummary: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandSpendSummary', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/audience/spend/summary`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AudienceSpendApi - functional programming interface
 * @export
 */
export const AudienceSpendApiFp = function (configuration) {
    const localVarAxiosParamCreator = AudienceSpendApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get spend data for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} [startDate] start date in UTC to filter spend
         * @param {string} [endDate] end date in UTC to filter spend
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSpend(brandId, startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandSpend(brandId, startDate, endDate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudienceSpendApi.getBrandSpend']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get spend data from brand that has monthly average spend and lifetime spend
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSpendSummary(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandSpendSummary(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudienceSpendApi.getBrandSpendSummary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AudienceSpendApi - factory interface
 * @export
 */
export const AudienceSpendApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AudienceSpendApiFp(configuration);
    return {
        /**
         *
         * @summary Get spend data for a brand
         * @param {AudienceSpendApiGetBrandSpendRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSpend(requestParameters, options) {
            return localVarFp.getBrandSpend(requestParameters.brandId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get spend data from brand that has monthly average spend and lifetime spend
         * @param {AudienceSpendApiGetBrandSpendSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSpendSummary(requestParameters, options) {
            return localVarFp.getBrandSpendSummary(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AudienceSpendApi - object-oriented interface
 * @export
 * @class AudienceSpendApi
 * @extends {BaseAPI}
 */
export class AudienceSpendApi extends BaseAPI {
    /**
     *
     * @summary Get spend data for a brand
     * @param {AudienceSpendApiGetBrandSpendRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudienceSpendApi
     */
    getBrandSpend(requestParameters, options) {
        return AudienceSpendApiFp(this.configuration).getBrandSpend(requestParameters.brandId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get spend data from brand that has monthly average spend and lifetime spend
     * @param {AudienceSpendApiGetBrandSpendSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudienceSpendApi
     */
    getBrandSpendSummary(requestParameters, options) {
        return AudienceSpendApiFp(this.configuration).getBrandSpendSummary(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AudiencesApi - axios parameter creator
 * @export
 */
export const AudiencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create an ad hoc seed audience for a brand
         * @summary Create an ad hoc seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {CreateAdHocSeedAudienceRequest} [createAdHocSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdHocSeedAudience: (brandId, createAdHocSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createAdHocSeedAudience', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/seed-audience/ad-hoc`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createAdHocSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a brand-overlap seed audience
         * @summary Create a brand-overlap seed audience
         * @param {CreateBrandOverlapSeedAudienceRequest} [createBrandOverlapSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandOverlapSeedAudience: (createBrandOverlapSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/seed-audience/brand-overlap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBrandOverlapSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a build-your-own seed audience
         * @summary Create a build-your-own seed audience
         * @param {CreateSelfServiceSeedAudienceRequest} [createSelfServiceSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuildYourOwnSeedAudience: (createSelfServiceSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/seed-audience/build-your-own`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSelfServiceSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create an enhanced lookalike seed audience
         * @summary Create an enhanced lookalike seed audience
         * @param {CreateSelfServiceSeedAudienceRequest} [createSelfServiceSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnhancedLookalikeSeedAudience: (createSelfServiceSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/seed-audience/enhanced-lookalike`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSelfServiceSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a lookalike audience for a seed audience
         * @summary Create a lookalike audience for a seed audience
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience to use in lookalike audience creation
         * @param {CreateLookalikeAudienceRequest} [createLookalikeAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLookalikeAudience: (brandId, seedAudienceId, createLookalikeAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createLookalikeAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('createLookalikeAudience', 'seedAudienceId', seedAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/lookalike-audience`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createLookalikeAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a seed audience for a brand
         * @summary Create a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {CreateSeedAudienceRequest} [createSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeedAudience: (brandId, createSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createSeedAudience', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/seed-audience`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a self-service seed audience
         * @summary Create a self-service seed audience
         * @param {CreateSelfServiceSeedAudienceRequest} [createSelfServiceSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSelfServiceSeedAudience: (createSelfServiceSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/seed-audience/self-service`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSelfServiceSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Trigger an event to delete a lookalike audience
         * @summary Trigger an event to delete a lookalike audience
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience with the associated lookalike audience
         * @param {string} lookalikeAudienceId ID of the lookalike audience that will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookalikeAudience: (brandId, seedAudienceId, lookalikeAudienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteLookalikeAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('deleteLookalikeAudience', 'seedAudienceId', seedAudienceId);
            // verify required parameter 'lookalikeAudienceId' is not null or undefined
            assertParamExists('deleteLookalikeAudience', 'lookalikeAudienceId', lookalikeAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/lookalike-audience/{lookalikeAudienceId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)))
                .replace(`{${"lookalikeAudienceId"}}`, encodeURIComponent(String(lookalikeAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Trigger an event to delete a seed audience
         * @summary Trigger an event to delete a seed audience
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience with the associated lookalike audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeedAudience: (brandId, seedAudienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteSeedAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('deleteSeedAudience', 'seedAudienceId', seedAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get audience related settings for a list of brands or all brands
         * @summary Get audience-related settings for a list of brands or all brands
         * @param {string} [brandId] comma delimited list of brandIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAudienceSettings: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/audience-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get available galaxies for a brand
         * @summary Get available galaxies for a brand
         * @param {string} brandId The brandId of the user
         * @param {boolean} [includeInternal] Whether to include internal galaxies
         * @param {boolean} [includeAllowMultipleAudiences] Whether to include galaxies allowing multiple audiences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableGalaxies: (brandId, includeInternal, includeAllowMultipleAudiences, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getAvailableGalaxies', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/galaxy/available`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (includeInternal !== undefined) {
                localVarQueryParameter['includeInternal'] = includeInternal;
            }
            if (includeAllowMultipleAudiences !== undefined) {
                localVarQueryParameter['includeAllowMultipleAudiences'] = includeAllowMultipleAudiences;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get audience-related settings for a brand
         * @summary Get audience-related settings for a brand
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSettings: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandSettings', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/audience-settings`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of flavor categories
         * @summary Get a list of flavor categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlavorCategories: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/flavor-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get lookalike audience sizes for a seed audience for a brand
         * @summary Get lookalike audience sizes for a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience used to create lookalike audiences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookalikeAudienceSizes: (brandId, seedAudienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getLookalikeAudienceSizes', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('getLookalikeAudienceSizes', 'seedAudienceId', seedAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/lookalike-audience/size`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get lookalike audience stats for a brand
         * @summary Get lookalike audience stats for a brand
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookalikeAudiencesStats: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getLookalikeAudiencesStats', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/lookalike-audience/stats`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a seed audience for a brand
         * @summary Retrieve a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The seed audience ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeedAudience: (brandId, seedAudienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getSeedAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('getSeedAudience', 'seedAudienceId', seedAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get seed audiences for a brand, regardless of platform or ad account
         * @summary Get seed audiences for a brand, regardless of platform or ad account
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeedAudiences: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getSeedAudiences', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/seed-audience`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Trigger an event to rename a lookalike audience
         * @summary Trigger an event to rename a lookalike audience
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience
         * @param {string} lookalikeAudienceId ID of the lookalike audience that will be renamed
         * @param {RenameAudienceRequest} renameAudienceRequest Audience to be renamed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameLookalikeAudience: (brandId, seedAudienceId, lookalikeAudienceId, renameAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('renameLookalikeAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('renameLookalikeAudience', 'seedAudienceId', seedAudienceId);
            // verify required parameter 'lookalikeAudienceId' is not null or undefined
            assertParamExists('renameLookalikeAudience', 'lookalikeAudienceId', lookalikeAudienceId);
            // verify required parameter 'renameAudienceRequest' is not null or undefined
            assertParamExists('renameLookalikeAudience', 'renameAudienceRequest', renameAudienceRequest);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/lookalike-audience/{lookalikeAudienceId}/rename`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)))
                .replace(`{${"lookalikeAudienceId"}}`, encodeURIComponent(String(lookalikeAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(renameAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Trigger an event to rename a seed audience and associated integration and lookalike audiences
         * @summary Trigger an event to rename a seed audience and associated integration and lookalike audiences
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience that will be renamed
         * @param {RenameAudienceRequest} renameAudienceRequest Audiences to be renamed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameSeedAudience: (brandId, seedAudienceId, renameAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('renameSeedAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('renameSeedAudience', 'seedAudienceId', seedAudienceId);
            // verify required parameter 'renameAudienceRequest' is not null or undefined
            assertParamExists('renameSeedAudience', 'renameAudienceRequest', renameAudienceRequest);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/rename`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(renameAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retries the creation of a lookalike audience
         * @summary Retries the creation of a lookalike audience
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience to use in lookalike audience creation
         * @param {string} lookalikeAudienceId The ID of the lookalike audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryLookalikeAudience: (brandId, seedAudienceId, lookalikeAudienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('retryLookalikeAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('retryLookalikeAudience', 'seedAudienceId', seedAudienceId);
            // verify required parameter 'lookalikeAudienceId' is not null or undefined
            assertParamExists('retryLookalikeAudience', 'lookalikeAudienceId', lookalikeAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/lookalike-audience/{lookalikeAudienceId}/retry`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)))
                .replace(`{${"lookalikeAudienceId"}}`, encodeURIComponent(String(lookalikeAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enable or disable automatic updates for one or more seed audiences
         * @summary Enable or disable automatic updates for one or more seed audiences
         * @param {string} brandId The brandId of the user
         * @param {UpdateAudienceUpdateSettingsRequest} [updateAudienceUpdateSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAudienceUpdateSettings: (brandId, updateAudienceUpdateSettingsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateAudienceUpdateSettings', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/audience-update`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateAudienceUpdateSettingsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update audience-related settings for a brand
         * @summary Update audience-related settings for a brand
         * @param {string} brandId The brandId of the user
         * @param {UpdateBrandSettingsRequest} [updateBrandSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandSettings: (brandId, updateBrandSettingsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateBrandSettings', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/audience-settings`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandSettingsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a seed audience for a brand
         * @summary Update a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The seed audience ID
         * @param {UpdateSeedAudienceRequest} [updateSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudience: (brandId, seedAudienceId, updateSeedAudienceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateSeedAudience', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('updateSeedAudience', 'seedAudienceId', seedAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSeedAudienceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Trigger an update for a seed of a seed audience
         * @summary Trigger an update for a seed of a seed audience
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience whose seed should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudienceSeed: (brandId, seedAudienceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateSeedAudienceSeed', 'brandId', brandId);
            // verify required parameter 'seedAudienceId' is not null or undefined
            assertParamExists('updateSeedAudienceSeed', 'seedAudienceId', seedAudienceId);
            const localVarPath = `/brand/{brandId}/seed-audience/{seedAudienceId}/update`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"seedAudienceId"}}`, encodeURIComponent(String(seedAudienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update seeds for one or more seed audiences
         * @summary Update seeds for one or more seed audiences
         * @param {Array<UpdateSeedAudienceSeedsRequestInner>} [updateSeedAudienceSeedsRequestInner]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudienceSeeds: (updateSeedAudienceSeedsRequestInner, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/seed-audience/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSeedAudienceSeedsRequestInner, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AudiencesApi - functional programming interface
 * @export
 */
export const AudiencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AudiencesApiAxiosParamCreator(configuration);
    return {
        /**
         * Create an ad hoc seed audience for a brand
         * @summary Create an ad hoc seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {CreateAdHocSeedAudienceRequest} [createAdHocSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdHocSeedAudience(brandId, createAdHocSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAdHocSeedAudience(brandId, createAdHocSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createAdHocSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a brand-overlap seed audience
         * @summary Create a brand-overlap seed audience
         * @param {CreateBrandOverlapSeedAudienceRequest} [createBrandOverlapSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandOverlapSeedAudience(createBrandOverlapSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBrandOverlapSeedAudience(createBrandOverlapSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createBrandOverlapSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a build-your-own seed audience
         * @summary Create a build-your-own seed audience
         * @param {CreateSelfServiceSeedAudienceRequest} [createSelfServiceSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuildYourOwnSeedAudience(createSelfServiceSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBuildYourOwnSeedAudience(createSelfServiceSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createBuildYourOwnSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create an enhanced lookalike seed audience
         * @summary Create an enhanced lookalike seed audience
         * @param {CreateSelfServiceSeedAudienceRequest} [createSelfServiceSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnhancedLookalikeSeedAudience(createSelfServiceSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createEnhancedLookalikeSeedAudience(createSelfServiceSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createEnhancedLookalikeSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a lookalike audience for a seed audience
         * @summary Create a lookalike audience for a seed audience
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience to use in lookalike audience creation
         * @param {CreateLookalikeAudienceRequest} [createLookalikeAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLookalikeAudience(brandId, seedAudienceId, createLookalikeAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createLookalikeAudience(brandId, seedAudienceId, createLookalikeAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createLookalikeAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a seed audience for a brand
         * @summary Create a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {CreateSeedAudienceRequest} [createSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeedAudience(brandId, createSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSeedAudience(brandId, createSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a self-service seed audience
         * @summary Create a self-service seed audience
         * @param {CreateSelfServiceSeedAudienceRequest} [createSelfServiceSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSelfServiceSeedAudience(createSelfServiceSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSelfServiceSeedAudience(createSelfServiceSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.createSelfServiceSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Trigger an event to delete a lookalike audience
         * @summary Trigger an event to delete a lookalike audience
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience with the associated lookalike audience
         * @param {string} lookalikeAudienceId ID of the lookalike audience that will be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookalikeAudience(brandId, seedAudienceId, lookalikeAudienceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteLookalikeAudience(brandId, seedAudienceId, lookalikeAudienceId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.deleteLookalikeAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Trigger an event to delete a seed audience
         * @summary Trigger an event to delete a seed audience
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience with the associated lookalike audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeedAudience(brandId, seedAudienceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSeedAudience(brandId, seedAudienceId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.deleteSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get audience related settings for a list of brands or all brands
         * @summary Get audience-related settings for a list of brands or all brands
         * @param {string} [brandId] comma delimited list of brandIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAudienceSettings(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAudienceSettings(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getAudienceSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get available galaxies for a brand
         * @summary Get available galaxies for a brand
         * @param {string} brandId The brandId of the user
         * @param {boolean} [includeInternal] Whether to include internal galaxies
         * @param {boolean} [includeAllowMultipleAudiences] Whether to include galaxies allowing multiple audiences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableGalaxies(brandId, includeInternal, includeAllowMultipleAudiences, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableGalaxies(brandId, includeInternal, includeAllowMultipleAudiences, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getAvailableGalaxies']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get audience-related settings for a brand
         * @summary Get audience-related settings for a brand
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSettings(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandSettings(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getBrandSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a list of flavor categories
         * @summary Get a list of flavor categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlavorCategories(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFlavorCategories(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getFlavorCategories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get lookalike audience sizes for a seed audience for a brand
         * @summary Get lookalike audience sizes for a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience used to create lookalike audiences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookalikeAudienceSizes(brandId, seedAudienceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLookalikeAudienceSizes(brandId, seedAudienceId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getLookalikeAudienceSizes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get lookalike audience stats for a brand
         * @summary Get lookalike audience stats for a brand
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookalikeAudiencesStats(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLookalikeAudiencesStats(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getLookalikeAudiencesStats']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve a seed audience for a brand
         * @summary Retrieve a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The seed audience ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeedAudience(brandId, seedAudienceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSeedAudience(brandId, seedAudienceId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get seed audiences for a brand, regardless of platform or ad account
         * @summary Get seed audiences for a brand, regardless of platform or ad account
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeedAudiences(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSeedAudiences(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.getSeedAudiences']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Trigger an event to rename a lookalike audience
         * @summary Trigger an event to rename a lookalike audience
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience
         * @param {string} lookalikeAudienceId ID of the lookalike audience that will be renamed
         * @param {RenameAudienceRequest} renameAudienceRequest Audience to be renamed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameLookalikeAudience(brandId, seedAudienceId, lookalikeAudienceId, renameAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.renameLookalikeAudience(brandId, seedAudienceId, lookalikeAudienceId, renameAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.renameLookalikeAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Trigger an event to rename a seed audience and associated integration and lookalike audiences
         * @summary Trigger an event to rename a seed audience and associated integration and lookalike audiences
         * @param {string} brandId ID of brand
         * @param {string} seedAudienceId ID of the seed audience that will be renamed
         * @param {RenameAudienceRequest} renameAudienceRequest Audiences to be renamed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameSeedAudience(brandId, seedAudienceId, renameAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.renameSeedAudience(brandId, seedAudienceId, renameAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.renameSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retries the creation of a lookalike audience
         * @summary Retries the creation of a lookalike audience
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience to use in lookalike audience creation
         * @param {string} lookalikeAudienceId The ID of the lookalike audience
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryLookalikeAudience(brandId, seedAudienceId, lookalikeAudienceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retryLookalikeAudience(brandId, seedAudienceId, lookalikeAudienceId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.retryLookalikeAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Enable or disable automatic updates for one or more seed audiences
         * @summary Enable or disable automatic updates for one or more seed audiences
         * @param {string} brandId The brandId of the user
         * @param {UpdateAudienceUpdateSettingsRequest} [updateAudienceUpdateSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAudienceUpdateSettings(brandId, updateAudienceUpdateSettingsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAudienceUpdateSettings(brandId, updateAudienceUpdateSettingsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.updateAudienceUpdateSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update audience-related settings for a brand
         * @summary Update audience-related settings for a brand
         * @param {string} brandId The brandId of the user
         * @param {UpdateBrandSettingsRequest} [updateBrandSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandSettings(brandId, updateBrandSettingsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateBrandSettings(brandId, updateBrandSettingsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.updateBrandSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a seed audience for a brand
         * @summary Update a seed audience for a brand
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The seed audience ID
         * @param {UpdateSeedAudienceRequest} [updateSeedAudienceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudience(brandId, seedAudienceId, updateSeedAudienceRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSeedAudience(brandId, seedAudienceId, updateSeedAudienceRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.updateSeedAudience']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Trigger an update for a seed of a seed audience
         * @summary Trigger an update for a seed of a seed audience
         * @param {string} brandId The brandId of the user
         * @param {string} seedAudienceId The ID of the seed audience whose seed should be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudienceSeed(brandId, seedAudienceId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSeedAudienceSeed(brandId, seedAudienceId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.updateSeedAudienceSeed']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update seeds for one or more seed audiences
         * @summary Update seeds for one or more seed audiences
         * @param {Array<UpdateSeedAudienceSeedsRequestInner>} [updateSeedAudienceSeedsRequestInner]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudienceSeeds(updateSeedAudienceSeedsRequestInner, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSeedAudienceSeeds(updateSeedAudienceSeedsRequestInner, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AudiencesApi.updateSeedAudienceSeeds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AudiencesApi - factory interface
 * @export
 */
export const AudiencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AudiencesApiFp(configuration);
    return {
        /**
         * Create an ad hoc seed audience for a brand
         * @summary Create an ad hoc seed audience for a brand
         * @param {AudiencesApiCreateAdHocSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdHocSeedAudience(requestParameters, options) {
            return localVarFp.createAdHocSeedAudience(requestParameters.brandId, requestParameters.createAdHocSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a brand-overlap seed audience
         * @summary Create a brand-overlap seed audience
         * @param {AudiencesApiCreateBrandOverlapSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandOverlapSeedAudience(requestParameters = {}, options) {
            return localVarFp.createBrandOverlapSeedAudience(requestParameters.createBrandOverlapSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a build-your-own seed audience
         * @summary Create a build-your-own seed audience
         * @param {AudiencesApiCreateBuildYourOwnSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBuildYourOwnSeedAudience(requestParameters = {}, options) {
            return localVarFp.createBuildYourOwnSeedAudience(requestParameters.createSelfServiceSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an enhanced lookalike seed audience
         * @summary Create an enhanced lookalike seed audience
         * @param {AudiencesApiCreateEnhancedLookalikeSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnhancedLookalikeSeedAudience(requestParameters = {}, options) {
            return localVarFp.createEnhancedLookalikeSeedAudience(requestParameters.createSelfServiceSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a lookalike audience for a seed audience
         * @summary Create a lookalike audience for a seed audience
         * @param {AudiencesApiCreateLookalikeAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLookalikeAudience(requestParameters, options) {
            return localVarFp.createLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.createLookalikeAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a seed audience for a brand
         * @summary Create a seed audience for a brand
         * @param {AudiencesApiCreateSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeedAudience(requestParameters, options) {
            return localVarFp.createSeedAudience(requestParameters.brandId, requestParameters.createSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a self-service seed audience
         * @summary Create a self-service seed audience
         * @param {AudiencesApiCreateSelfServiceSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSelfServiceSeedAudience(requestParameters = {}, options) {
            return localVarFp.createSelfServiceSeedAudience(requestParameters.createSelfServiceSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger an event to delete a lookalike audience
         * @summary Trigger an event to delete a lookalike audience
         * @param {AudiencesApiDeleteLookalikeAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLookalikeAudience(requestParameters, options) {
            return localVarFp.deleteLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.lookalikeAudienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger an event to delete a seed audience
         * @summary Trigger an event to delete a seed audience
         * @param {AudiencesApiDeleteSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSeedAudience(requestParameters, options) {
            return localVarFp.deleteSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audience related settings for a list of brands or all brands
         * @summary Get audience-related settings for a list of brands or all brands
         * @param {AudiencesApiGetAudienceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAudienceSettings(requestParameters = {}, options) {
            return localVarFp.getAudienceSettings(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get available galaxies for a brand
         * @summary Get available galaxies for a brand
         * @param {AudiencesApiGetAvailableGalaxiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableGalaxies(requestParameters, options) {
            return localVarFp.getAvailableGalaxies(requestParameters.brandId, requestParameters.includeInternal, requestParameters.includeAllowMultipleAudiences, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audience-related settings for a brand
         * @summary Get audience-related settings for a brand
         * @param {AudiencesApiGetBrandSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandSettings(requestParameters, options) {
            return localVarFp.getBrandSettings(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of flavor categories
         * @summary Get a list of flavor categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlavorCategories(options) {
            return localVarFp.getFlavorCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * Get lookalike audience sizes for a seed audience for a brand
         * @summary Get lookalike audience sizes for a seed audience for a brand
         * @param {AudiencesApiGetLookalikeAudienceSizesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookalikeAudienceSizes(requestParameters, options) {
            return localVarFp.getLookalikeAudienceSizes(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get lookalike audience stats for a brand
         * @summary Get lookalike audience stats for a brand
         * @param {AudiencesApiGetLookalikeAudiencesStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookalikeAudiencesStats(requestParameters, options) {
            return localVarFp.getLookalikeAudiencesStats(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a seed audience for a brand
         * @summary Retrieve a seed audience for a brand
         * @param {AudiencesApiGetSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeedAudience(requestParameters, options) {
            return localVarFp.getSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get seed audiences for a brand, regardless of platform or ad account
         * @summary Get seed audiences for a brand, regardless of platform or ad account
         * @param {AudiencesApiGetSeedAudiencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeedAudiences(requestParameters, options) {
            return localVarFp.getSeedAudiences(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger an event to rename a lookalike audience
         * @summary Trigger an event to rename a lookalike audience
         * @param {AudiencesApiRenameLookalikeAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameLookalikeAudience(requestParameters, options) {
            return localVarFp.renameLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.lookalikeAudienceId, requestParameters.renameAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger an event to rename a seed audience and associated integration and lookalike audiences
         * @summary Trigger an event to rename a seed audience and associated integration and lookalike audiences
         * @param {AudiencesApiRenameSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameSeedAudience(requestParameters, options) {
            return localVarFp.renameSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.renameAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retries the creation of a lookalike audience
         * @summary Retries the creation of a lookalike audience
         * @param {AudiencesApiRetryLookalikeAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryLookalikeAudience(requestParameters, options) {
            return localVarFp.retryLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.lookalikeAudienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable automatic updates for one or more seed audiences
         * @summary Enable or disable automatic updates for one or more seed audiences
         * @param {AudiencesApiUpdateAudienceUpdateSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAudienceUpdateSettings(requestParameters, options) {
            return localVarFp.updateAudienceUpdateSettings(requestParameters.brandId, requestParameters.updateAudienceUpdateSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update audience-related settings for a brand
         * @summary Update audience-related settings for a brand
         * @param {AudiencesApiUpdateBrandSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandSettings(requestParameters, options) {
            return localVarFp.updateBrandSettings(requestParameters.brandId, requestParameters.updateBrandSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a seed audience for a brand
         * @summary Update a seed audience for a brand
         * @param {AudiencesApiUpdateSeedAudienceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudience(requestParameters, options) {
            return localVarFp.updateSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.updateSeedAudienceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger an update for a seed of a seed audience
         * @summary Trigger an update for a seed of a seed audience
         * @param {AudiencesApiUpdateSeedAudienceSeedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudienceSeed(requestParameters, options) {
            return localVarFp.updateSeedAudienceSeed(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update seeds for one or more seed audiences
         * @summary Update seeds for one or more seed audiences
         * @param {AudiencesApiUpdateSeedAudienceSeedsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeedAudienceSeeds(requestParameters = {}, options) {
            return localVarFp.updateSeedAudienceSeeds(requestParameters.updateSeedAudienceSeedsRequestInner, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AudiencesApi - object-oriented interface
 * @export
 * @class AudiencesApi
 * @extends {BaseAPI}
 */
export class AudiencesApi extends BaseAPI {
    /**
     * Create an ad hoc seed audience for a brand
     * @summary Create an ad hoc seed audience for a brand
     * @param {AudiencesApiCreateAdHocSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createAdHocSeedAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).createAdHocSeedAudience(requestParameters.brandId, requestParameters.createAdHocSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a brand-overlap seed audience
     * @summary Create a brand-overlap seed audience
     * @param {AudiencesApiCreateBrandOverlapSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createBrandOverlapSeedAudience(requestParameters = {}, options) {
        return AudiencesApiFp(this.configuration).createBrandOverlapSeedAudience(requestParameters.createBrandOverlapSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a build-your-own seed audience
     * @summary Create a build-your-own seed audience
     * @param {AudiencesApiCreateBuildYourOwnSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createBuildYourOwnSeedAudience(requestParameters = {}, options) {
        return AudiencesApiFp(this.configuration).createBuildYourOwnSeedAudience(requestParameters.createSelfServiceSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create an enhanced lookalike seed audience
     * @summary Create an enhanced lookalike seed audience
     * @param {AudiencesApiCreateEnhancedLookalikeSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createEnhancedLookalikeSeedAudience(requestParameters = {}, options) {
        return AudiencesApiFp(this.configuration).createEnhancedLookalikeSeedAudience(requestParameters.createSelfServiceSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a lookalike audience for a seed audience
     * @summary Create a lookalike audience for a seed audience
     * @param {AudiencesApiCreateLookalikeAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createLookalikeAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).createLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.createLookalikeAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a seed audience for a brand
     * @summary Create a seed audience for a brand
     * @param {AudiencesApiCreateSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createSeedAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).createSeedAudience(requestParameters.brandId, requestParameters.createSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a self-service seed audience
     * @summary Create a self-service seed audience
     * @param {AudiencesApiCreateSelfServiceSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    createSelfServiceSeedAudience(requestParameters = {}, options) {
        return AudiencesApiFp(this.configuration).createSelfServiceSeedAudience(requestParameters.createSelfServiceSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Trigger an event to delete a lookalike audience
     * @summary Trigger an event to delete a lookalike audience
     * @param {AudiencesApiDeleteLookalikeAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    deleteLookalikeAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).deleteLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.lookalikeAudienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Trigger an event to delete a seed audience
     * @summary Trigger an event to delete a seed audience
     * @param {AudiencesApiDeleteSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    deleteSeedAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).deleteSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get audience related settings for a list of brands or all brands
     * @summary Get audience-related settings for a list of brands or all brands
     * @param {AudiencesApiGetAudienceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getAudienceSettings(requestParameters = {}, options) {
        return AudiencesApiFp(this.configuration).getAudienceSettings(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get available galaxies for a brand
     * @summary Get available galaxies for a brand
     * @param {AudiencesApiGetAvailableGalaxiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getAvailableGalaxies(requestParameters, options) {
        return AudiencesApiFp(this.configuration).getAvailableGalaxies(requestParameters.brandId, requestParameters.includeInternal, requestParameters.includeAllowMultipleAudiences, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get audience-related settings for a brand
     * @summary Get audience-related settings for a brand
     * @param {AudiencesApiGetBrandSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getBrandSettings(requestParameters, options) {
        return AudiencesApiFp(this.configuration).getBrandSettings(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of flavor categories
     * @summary Get a list of flavor categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getFlavorCategories(options) {
        return AudiencesApiFp(this.configuration).getFlavorCategories(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get lookalike audience sizes for a seed audience for a brand
     * @summary Get lookalike audience sizes for a seed audience for a brand
     * @param {AudiencesApiGetLookalikeAudienceSizesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getLookalikeAudienceSizes(requestParameters, options) {
        return AudiencesApiFp(this.configuration).getLookalikeAudienceSizes(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get lookalike audience stats for a brand
     * @summary Get lookalike audience stats for a brand
     * @param {AudiencesApiGetLookalikeAudiencesStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getLookalikeAudiencesStats(requestParameters, options) {
        return AudiencesApiFp(this.configuration).getLookalikeAudiencesStats(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a seed audience for a brand
     * @summary Retrieve a seed audience for a brand
     * @param {AudiencesApiGetSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getSeedAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).getSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get seed audiences for a brand, regardless of platform or ad account
     * @summary Get seed audiences for a brand, regardless of platform or ad account
     * @param {AudiencesApiGetSeedAudiencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    getSeedAudiences(requestParameters, options) {
        return AudiencesApiFp(this.configuration).getSeedAudiences(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Trigger an event to rename a lookalike audience
     * @summary Trigger an event to rename a lookalike audience
     * @param {AudiencesApiRenameLookalikeAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    renameLookalikeAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).renameLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.lookalikeAudienceId, requestParameters.renameAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Trigger an event to rename a seed audience and associated integration and lookalike audiences
     * @summary Trigger an event to rename a seed audience and associated integration and lookalike audiences
     * @param {AudiencesApiRenameSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    renameSeedAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).renameSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.renameAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retries the creation of a lookalike audience
     * @summary Retries the creation of a lookalike audience
     * @param {AudiencesApiRetryLookalikeAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    retryLookalikeAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).retryLookalikeAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.lookalikeAudienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Enable or disable automatic updates for one or more seed audiences
     * @summary Enable or disable automatic updates for one or more seed audiences
     * @param {AudiencesApiUpdateAudienceUpdateSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    updateAudienceUpdateSettings(requestParameters, options) {
        return AudiencesApiFp(this.configuration).updateAudienceUpdateSettings(requestParameters.brandId, requestParameters.updateAudienceUpdateSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update audience-related settings for a brand
     * @summary Update audience-related settings for a brand
     * @param {AudiencesApiUpdateBrandSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    updateBrandSettings(requestParameters, options) {
        return AudiencesApiFp(this.configuration).updateBrandSettings(requestParameters.brandId, requestParameters.updateBrandSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a seed audience for a brand
     * @summary Update a seed audience for a brand
     * @param {AudiencesApiUpdateSeedAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    updateSeedAudience(requestParameters, options) {
        return AudiencesApiFp(this.configuration).updateSeedAudience(requestParameters.brandId, requestParameters.seedAudienceId, requestParameters.updateSeedAudienceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Trigger an update for a seed of a seed audience
     * @summary Trigger an update for a seed of a seed audience
     * @param {AudiencesApiUpdateSeedAudienceSeedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    updateSeedAudienceSeed(requestParameters, options) {
        return AudiencesApiFp(this.configuration).updateSeedAudienceSeed(requestParameters.brandId, requestParameters.seedAudienceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update seeds for one or more seed audiences
     * @summary Update seeds for one or more seed audiences
     * @param {AudiencesApiUpdateSeedAudienceSeedsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AudiencesApi
     */
    updateSeedAudienceSeeds(requestParameters = {}, options) {
        return AudiencesApiFp(this.configuration).updateSeedAudienceSeeds(requestParameters.updateSeedAudienceSeedsRequestInner, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * cancels a Shopify subscription
         * @summary cancels a Shopify subscription
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('cancelSubscription', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/shopify/subscription`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a contact
         * @summary Create a contact
         * @param {string} brandId id of brand
         * @param {CreateContact} createContact Contact to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: (brandId, createContact, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createContact', 'brandId', brandId);
            // verify required parameter 'createContact' is not null or undefined
            assertParamExists('createContact', 'createContact', createContact);
            const localVarPath = `/brand/${brandId}/billing/contact`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createContact, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a customer portal session
         * @summary Create a customer portal session
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerPortalSession: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createCustomerPortalSession', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/stripe/customer-portal`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * creates a Shopify subscription
         * @summary creates a Shopify subscription
         * @param {string} brandId The brandId of the user
         * @param {CreateSubscriptionInput} [createSubscriptionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: (brandId, createSubscriptionInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createSubscription', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/shopify/subscription`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a contact
         * @summary Delete a contact
         * @param {string} brandId id of brand
         * @param {string} contactId id of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: (brandId, contactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteContact', 'brandId', brandId);
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContact', 'contactId', contactId);
            const localVarPath = `/brand/{brandId}/contact/{contactId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all contacts for a brand
         * @summary Get all contacts for a brand
         * @param {string} brandId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandContacts: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandContacts', 'brandId', brandId);
            const localVarPath = `/brand/${brandId}/billing/contact`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get stripe subscription for a brand
         * @summary Get stripe subscription for a brand
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getSubscription', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/subscription`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * returns shopify billing subscription
         * @summary returns shopify billing subscription
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription1: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getSubscription1', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/shopify/subscription`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a subscription based on the subscription type
         * @summary Update a subscription
         * @param {string} brandId The brandId of the user
         * @param {UpdateSubscriptionInput} [updateSubscriptionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: (brandId, updateSubscriptionInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateSubscription', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/subscription`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * confirms charges were accepted for Shopify subscription
         * @summary confirms charges were accepted for Shopify subscription
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAcceptedCharges: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('userAcceptedCharges', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/billing/shopify/subscription/charges-accepted`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function (configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration);
    return {
        /**
         * cancels a Shopify subscription
         * @summary cancels a Shopify subscription
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelSubscription(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.cancelSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a contact
         * @summary Create a contact
         * @param {string} brandId id of brand
         * @param {CreateContact} createContact Contact to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(brandId, createContact, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createContact(brandId, createContact, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.createContact']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a customer portal session
         * @summary Create a customer portal session
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerPortalSession(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCustomerPortalSession(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.createCustomerPortalSession']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * creates a Shopify subscription
         * @summary creates a Shopify subscription
         * @param {string} brandId The brandId of the user
         * @param {CreateSubscriptionInput} [createSubscriptionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(brandId, createSubscriptionInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSubscription(brandId, createSubscriptionInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.createSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete a contact
         * @summary Delete a contact
         * @param {string} brandId id of brand
         * @param {string} contactId id of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(brandId, contactId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteContact(brandId, contactId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.deleteContact']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all contacts for a brand
         * @summary Get all contacts for a brand
         * @param {string} brandId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandContacts(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandContacts(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.getBrandContacts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get stripe subscription for a brand
         * @summary Get stripe subscription for a brand
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscription(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.getSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * returns shopify billing subscription
         * @summary returns shopify billing subscription
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription1(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSubscription1(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.getSubscription1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Updates a subscription based on the subscription type
         * @summary Update a subscription
         * @param {string} brandId The brandId of the user
         * @param {UpdateSubscriptionInput} [updateSubscriptionInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(brandId, updateSubscriptionInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSubscription(brandId, updateSubscriptionInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.updateSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * confirms charges were accepted for Shopify subscription
         * @summary confirms charges were accepted for Shopify subscription
         * @param {string} brandId The brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAcceptedCharges(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userAcceptedCharges(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BillingApi.userAcceptedCharges']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BillingApiFp(configuration);
    return {
        /**
         * cancels a Shopify subscription
         * @summary cancels a Shopify subscription
         * @param {BillingApiCancelSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(requestParameters, options) {
            return localVarFp.cancelSubscription(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a contact
         * @summary Create a contact
         * @param {BillingApiCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(requestParameters, options) {
            return localVarFp.createContact(requestParameters.brandId, requestParameters.createContact, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a customer portal session
         * @summary Create a customer portal session
         * @param {BillingApiCreateCustomerPortalSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerPortalSession(requestParameters, options) {
            return localVarFp.createCustomerPortalSession(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * creates a Shopify subscription
         * @summary creates a Shopify subscription
         * @param {BillingApiCreateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(requestParameters, options) {
            return localVarFp.createSubscription(requestParameters.brandId, requestParameters.createSubscriptionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a contact
         * @summary Delete a contact
         * @param {BillingApiDeleteContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(requestParameters, options) {
            return localVarFp.deleteContact(requestParameters.brandId, requestParameters.contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all contacts for a brand
         * @summary Get all contacts for a brand
         * @param {BillingApiGetBrandContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandContacts(requestParameters, options) {
            return localVarFp.getBrandContacts(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get stripe subscription for a brand
         * @summary Get stripe subscription for a brand
         * @param {BillingApiGetSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(requestParameters, options) {
            return localVarFp.getSubscription(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * returns shopify billing subscription
         * @summary returns shopify billing subscription
         * @param {BillingApiGetSubscription1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription1(requestParameters, options) {
            return localVarFp.getSubscription1(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a subscription based on the subscription type
         * @summary Update a subscription
         * @param {BillingApiUpdateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(requestParameters, options) {
            return localVarFp.updateSubscription(requestParameters.brandId, requestParameters.updateSubscriptionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * confirms charges were accepted for Shopify subscription
         * @summary confirms charges were accepted for Shopify subscription
         * @param {BillingApiUserAcceptedChargesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAcceptedCharges(requestParameters, options) {
            return localVarFp.userAcceptedCharges(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * cancels a Shopify subscription
     * @summary cancels a Shopify subscription
     * @param {BillingApiCancelSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    cancelSubscription(requestParameters, options) {
        return BillingApiFp(this.configuration).cancelSubscription(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a contact
     * @summary Create a contact
     * @param {BillingApiCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    createContact(requestParameters, options) {
        return BillingApiFp(this.configuration).createContact(requestParameters.brandId, requestParameters.createContact, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a customer portal session
     * @summary Create a customer portal session
     * @param {BillingApiCreateCustomerPortalSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    createCustomerPortalSession(requestParameters, options) {
        return BillingApiFp(this.configuration).createCustomerPortalSession(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * creates a Shopify subscription
     * @summary creates a Shopify subscription
     * @param {BillingApiCreateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    createSubscription(requestParameters, options) {
        return BillingApiFp(this.configuration).createSubscription(requestParameters.brandId, requestParameters.createSubscriptionInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a contact
     * @summary Delete a contact
     * @param {BillingApiDeleteContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    deleteContact(requestParameters, options) {
        return BillingApiFp(this.configuration).deleteContact(requestParameters.brandId, requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all contacts for a brand
     * @summary Get all contacts for a brand
     * @param {BillingApiGetBrandContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    getBrandContacts(requestParameters, options) {
        return BillingApiFp(this.configuration).getBrandContacts(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get stripe subscription for a brand
     * @summary Get stripe subscription for a brand
     * @param {BillingApiGetSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    getSubscription(requestParameters, options) {
        return BillingApiFp(this.configuration).getSubscription(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * returns shopify billing subscription
     * @summary returns shopify billing subscription
     * @param {BillingApiGetSubscription1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    getSubscription1(requestParameters, options) {
        return BillingApiFp(this.configuration).getSubscription1(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a subscription based on the subscription type
     * @summary Update a subscription
     * @param {BillingApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    updateSubscription(requestParameters, options) {
        return BillingApiFp(this.configuration).updateSubscription(requestParameters.brandId, requestParameters.updateSubscriptionInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * confirms charges were accepted for Shopify subscription
     * @summary confirms charges were accepted for Shopify subscription
     * @param {BillingApiUserAcceptedChargesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    userAcceptedCharges(requestParameters, options) {
        return BillingApiFp(this.configuration).userAcceptedCharges(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BrandsApi - axios parameter creator
 * @export
 */
export const BrandsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a brand
         * @summary Create a brand
         * @param {CreateBrandRequest} createBrandRequest Brand to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: (createBrandRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createBrandRequest' is not null or undefined
            assertParamExists('createBrand', 'createBrandRequest', createBrandRequest);
            const localVarPath = `/brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBrandRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary deletes a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a user from a brand
         * @param {string} userId id of the user
         * @param {string} brandId id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromBrand: (userId, brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserFromBrand', 'userId', userId);
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteUserFromBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all brands
         * @summary Get all brands
         * @param {string} [search] search term
         * @param {string} [plans] comma seperated plans to filter on
         * @param {string} [spend] boolean as a string to determine if we want to include spend or not
         * @param {number} [pageNumber] page number (default 1)
         * @param {number} [pageSize] page size (default 25, max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrands: (search, plans, spend, pageNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (plans !== undefined) {
                localVarQueryParameter['plans'] = plans;
            }
            if (spend !== undefined) {
                localVarQueryParameter['spend'] = spend;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all users for a brand
         * @param {string} brandId id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersForBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getAllUsersForBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/user`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a brand
         * @summary Get a brand
         * @param {string} brandId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get brand batch
         * @summary Get a batch of brands
         * @param {string} brandId comma delimited list of brandIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBatch: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandBatch', 'brandId', brandId);
            const localVarPath = `/brand/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get brand customer settings
         * @summary Get brand customer settings
         * @param {string} brandId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCustomerSettings: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandCustomerSettings', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/customer/settings`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a user within a brand (confirms access)
         * @param {string} userId id of the user
         * @param {string} brandId id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandUser: (userId, brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBrandUser', 'userId', userId);
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandUser', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get warnings for brand
         * @summary Get warnings for brand
         * @param {string} brandId the id of the brand
         * @param {string} [nextToken] nextToken from previous request
         * @param {number} [pageSize] page size (default 25, max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandWarnings: (brandId, nextToken, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandWarnings', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/warning`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (nextToken !== undefined) {
                localVarQueryParameter['nextToken'] = nextToken;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Lock a brand
         * @summary Locks a brand
         * @param {string} brandId the id of the brand
         * @param {BrandLockRequest} brandLockRequest Selected audience option for brand lock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockBrand: (brandId, brandLockRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('lockBrand', 'brandId', brandId);
            // verify required parameter 'brandLockRequest' is not null or undefined
            assertParamExists('lockBrand', 'brandLockRequest', brandLockRequest);
            const localVarPath = `/brand/{brandId}/lock`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(brandLockRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * set the partner id on a brand
         * @summary a temporary endpoint to run a migration to set the partner id
         * @param {string} brandId id of brand
         * @param {SetPartnerIdRequest} setPartnerIdRequest Partner id to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerId: (brandId, setPartnerIdRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('setPartnerId', 'brandId', brandId);
            // verify required parameter 'setPartnerIdRequest' is not null or undefined
            assertParamExists('setPartnerId', 'setPartnerIdRequest', setPartnerIdRequest);
            const localVarPath = `/brand/{brandId}/partner`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setPartnerIdRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Unlock a brand
         * @summary Unlock a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('unlockBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/unlock`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Adds a user to a brand, or changes their role
         * @param {string} brandId id of brand to add user to
         * @param {UpdateAccessRequest} updateAccessRequest update access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccess: (brandId, updateAccessRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateAccess', 'brandId', brandId);
            // verify required parameter 'updateAccessRequest' is not null or undefined
            assertParamExists('updateAccess', 'updateAccessRequest', updateAccessRequest);
            const localVarPath = `/brand/{brandId}/user`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccessRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a brand
         * @summary Update a brand
         * @param {string} brandId id of brand
         * @param {UpdateBrandRequest} updateBrandRequest Brand data to be update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: (brandId, updateBrandRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateBrand', 'brandId', brandId);
            // verify required parameter 'updateBrandRequest' is not null or undefined
            assertParamExists('updateBrand', 'updateBrandRequest', updateBrandRequest);
            const localVarPath = `/brand/{brandId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBrandRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a batch request for csv file to be uploaded for customer profiles
         * @summary Create a batch request for csv file to be uploaded for customer profiles
         * @param {string} brandId The brandId of the user
         * @param {UploadCustomerBatchRequest} [uploadCustomerBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerBatch: (brandId, uploadCustomerBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('uploadCustomerBatch', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/customer/batch`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(uploadCustomerBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the status for batch
         * @summary Update the status for batch
         * @param {string} brandId The brandId of the user
         * @param {string} batchId id of the uploaded batch
         * @param {UploadCustomerBatchStatusRequest} [uploadCustomerBatchStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerBatchStatus: (brandId, batchId, uploadCustomerBatchStatusRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('uploadCustomerBatchStatus', 'brandId', brandId);
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('uploadCustomerBatchStatus', 'batchId', batchId);
            const localVarPath = `/brand/{brandId}/customer/batch/{batchId}/status`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(uploadCustomerBatchStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update or create settings for a brand customer
         * @summary Update or create settings for a brand customer
         * @param {string} brandId The brandId of the user
         * @param {UpsertBrandCustomerSettings} upsertBrandCustomerSettings Update values for brand customer settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBrandCustomerSettings: (brandId, upsertBrandCustomerSettings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('upsertBrandCustomerSettings', 'brandId', brandId);
            // verify required parameter 'upsertBrandCustomerSettings' is not null or undefined
            assertParamExists('upsertBrandCustomerSettings', 'upsertBrandCustomerSettings', upsertBrandCustomerSettings);
            const localVarPath = `/brand/{brandId}/customer/settings`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(upsertBrandCustomerSettings, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BrandsApi - functional programming interface
 * @export
 */
export const BrandsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BrandsApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a brand
         * @summary Create a brand
         * @param {CreateBrandRequest} createBrandRequest Brand to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand(createBrandRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBrand(createBrandRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.createBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary deletes a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.deleteBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Deletes a user from a brand
         * @param {string} userId id of the user
         * @param {string} brandId id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromBrand(userId, brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserFromBrand(userId, brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.deleteUserFromBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all brands
         * @summary Get all brands
         * @param {string} [search] search term
         * @param {string} [plans] comma seperated plans to filter on
         * @param {string} [spend] boolean as a string to determine if we want to include spend or not
         * @param {number} [pageNumber] page number (default 1)
         * @param {number} [pageSize] page size (default 25, max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrands(search, plans, spend, pageNumber, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBrands(search, plans, spend, pageNumber, pageSize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getAllBrands']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all users for a brand
         * @param {string} brandId id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersForBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUsersForBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getAllUsersForBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a brand
         * @summary Get a brand
         * @param {string} brandId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get brand batch
         * @summary Get a batch of brands
         * @param {string} brandId comma delimited list of brandIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBatch(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandBatch(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getBrandBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get brand customer settings
         * @summary Get brand customer settings
         * @param {string} brandId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCustomerSettings(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandCustomerSettings(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getBrandCustomerSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a user within a brand (confirms access)
         * @param {string} userId id of the user
         * @param {string} brandId id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandUser(userId, brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandUser(userId, brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getBrandUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get warnings for brand
         * @summary Get warnings for brand
         * @param {string} brandId the id of the brand
         * @param {string} [nextToken] nextToken from previous request
         * @param {number} [pageSize] page size (default 25, max 50)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandWarnings(brandId, nextToken, pageSize, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandWarnings(brandId, nextToken, pageSize, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.getBrandWarnings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Lock a brand
         * @summary Locks a brand
         * @param {string} brandId the id of the brand
         * @param {BrandLockRequest} brandLockRequest Selected audience option for brand lock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockBrand(brandId, brandLockRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.lockBrand(brandId, brandLockRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.lockBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * set the partner id on a brand
         * @summary a temporary endpoint to run a migration to set the partner id
         * @param {string} brandId id of brand
         * @param {SetPartnerIdRequest} setPartnerIdRequest Partner id to set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerId(brandId, setPartnerIdRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setPartnerId(brandId, setPartnerIdRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.setPartnerId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Unlock a brand
         * @summary Unlock a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unlockBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.unlockBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Adds a user to a brand, or changes their role
         * @param {string} brandId id of brand to add user to
         * @param {UpdateAccessRequest} updateAccessRequest update access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccess(brandId, updateAccessRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAccess(brandId, updateAccessRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.updateAccess']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update a brand
         * @summary Update a brand
         * @param {string} brandId id of brand
         * @param {UpdateBrandRequest} updateBrandRequest Brand data to be update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand(brandId, updateBrandRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateBrand(brandId, updateBrandRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.updateBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create a batch request for csv file to be uploaded for customer profiles
         * @summary Create a batch request for csv file to be uploaded for customer profiles
         * @param {string} brandId The brandId of the user
         * @param {UploadCustomerBatchRequest} [uploadCustomerBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerBatch(brandId, uploadCustomerBatchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadCustomerBatch(brandId, uploadCustomerBatchRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.uploadCustomerBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update the status for batch
         * @summary Update the status for batch
         * @param {string} brandId The brandId of the user
         * @param {string} batchId id of the uploaded batch
         * @param {UploadCustomerBatchStatusRequest} [uploadCustomerBatchStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerBatchStatus(brandId, batchId, uploadCustomerBatchStatusRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadCustomerBatchStatus(brandId, batchId, uploadCustomerBatchStatusRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.uploadCustomerBatchStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Update or create settings for a brand customer
         * @summary Update or create settings for a brand customer
         * @param {string} brandId The brandId of the user
         * @param {UpsertBrandCustomerSettings} upsertBrandCustomerSettings Update values for brand customer settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBrandCustomerSettings(brandId, upsertBrandCustomerSettings, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertBrandCustomerSettings(brandId, upsertBrandCustomerSettings, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BrandsApi.upsertBrandCustomerSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * BrandsApi - factory interface
 * @export
 */
export const BrandsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BrandsApiFp(configuration);
    return {
        /**
         * Create a brand
         * @summary Create a brand
         * @param {BrandsApiCreateBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand(requestParameters, options) {
            return localVarFp.createBrand(requestParameters.createBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary deletes a brand
         * @param {BrandsApiDeleteBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand(requestParameters, options) {
            return localVarFp.deleteBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a user from a brand
         * @param {BrandsApiDeleteUserFromBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserFromBrand(requestParameters, options) {
            return localVarFp.deleteUserFromBrand(requestParameters.userId, requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all brands
         * @summary Get all brands
         * @param {BrandsApiGetAllBrandsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrands(requestParameters = {}, options) {
            return localVarFp.getAllBrands(requestParameters.search, requestParameters.plans, requestParameters.spend, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all users for a brand
         * @param {BrandsApiGetAllUsersForBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersForBrand(requestParameters, options) {
            return localVarFp.getAllUsersForBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a brand
         * @summary Get a brand
         * @param {BrandsApiGetBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand(requestParameters, options) {
            return localVarFp.getBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand batch
         * @summary Get a batch of brands
         * @param {BrandsApiGetBrandBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandBatch(requestParameters, options) {
            return localVarFp.getBrandBatch(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand customer settings
         * @summary Get brand customer settings
         * @param {BrandsApiGetBrandCustomerSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandCustomerSettings(requestParameters, options) {
            return localVarFp.getBrandCustomerSettings(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user within a brand (confirms access)
         * @param {BrandsApiGetBrandUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandUser(requestParameters, options) {
            return localVarFp.getBrandUser(requestParameters.userId, requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get warnings for brand
         * @summary Get warnings for brand
         * @param {BrandsApiGetBrandWarningsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandWarnings(requestParameters, options) {
            return localVarFp.getBrandWarnings(requestParameters.brandId, requestParameters.nextToken, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Lock a brand
         * @summary Locks a brand
         * @param {BrandsApiLockBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockBrand(requestParameters, options) {
            return localVarFp.lockBrand(requestParameters.brandId, requestParameters.brandLockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * set the partner id on a brand
         * @summary a temporary endpoint to run a migration to set the partner id
         * @param {BrandsApiSetPartnerIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPartnerId(requestParameters, options) {
            return localVarFp.setPartnerId(requestParameters.brandId, requestParameters.setPartnerIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlock a brand
         * @summary Unlock a brand
         * @param {BrandsApiUnlockBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBrand(requestParameters, options) {
            return localVarFp.unlockBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a user to a brand, or changes their role
         * @param {BrandsApiUpdateAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccess(requestParameters, options) {
            return localVarFp.updateAccess(requestParameters.brandId, requestParameters.updateAccessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a brand
         * @summary Update a brand
         * @param {BrandsApiUpdateBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand(requestParameters, options) {
            return localVarFp.updateBrand(requestParameters.brandId, requestParameters.updateBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a batch request for csv file to be uploaded for customer profiles
         * @summary Create a batch request for csv file to be uploaded for customer profiles
         * @param {BrandsApiUploadCustomerBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerBatch(requestParameters, options) {
            return localVarFp.uploadCustomerBatch(requestParameters.brandId, requestParameters.uploadCustomerBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status for batch
         * @summary Update the status for batch
         * @param {BrandsApiUploadCustomerBatchStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomerBatchStatus(requestParameters, options) {
            return localVarFp.uploadCustomerBatchStatus(requestParameters.brandId, requestParameters.batchId, requestParameters.uploadCustomerBatchStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update or create settings for a brand customer
         * @summary Update or create settings for a brand customer
         * @param {BrandsApiUpsertBrandCustomerSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBrandCustomerSettings(requestParameters, options) {
            return localVarFp.upsertBrandCustomerSettings(requestParameters.brandId, requestParameters.upsertBrandCustomerSettings, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BrandsApi - object-oriented interface
 * @export
 * @class BrandsApi
 * @extends {BaseAPI}
 */
export class BrandsApi extends BaseAPI {
    /**
     * Create a brand
     * @summary Create a brand
     * @param {BrandsApiCreateBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    createBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).createBrand(requestParameters.createBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary deletes a brand
     * @param {BrandsApiDeleteBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    deleteBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).deleteBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a user from a brand
     * @param {BrandsApiDeleteUserFromBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    deleteUserFromBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).deleteUserFromBrand(requestParameters.userId, requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all brands
     * @summary Get all brands
     * @param {BrandsApiGetAllBrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getAllBrands(requestParameters = {}, options) {
        return BrandsApiFp(this.configuration).getAllBrands(requestParameters.search, requestParameters.plans, requestParameters.spend, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all users for a brand
     * @param {BrandsApiGetAllUsersForBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getAllUsersForBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).getAllUsersForBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a brand
     * @summary Get a brand
     * @param {BrandsApiGetBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).getBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get brand batch
     * @summary Get a batch of brands
     * @param {BrandsApiGetBrandBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getBrandBatch(requestParameters, options) {
        return BrandsApiFp(this.configuration).getBrandBatch(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get brand customer settings
     * @summary Get brand customer settings
     * @param {BrandsApiGetBrandCustomerSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getBrandCustomerSettings(requestParameters, options) {
        return BrandsApiFp(this.configuration).getBrandCustomerSettings(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a user within a brand (confirms access)
     * @param {BrandsApiGetBrandUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getBrandUser(requestParameters, options) {
        return BrandsApiFp(this.configuration).getBrandUser(requestParameters.userId, requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get warnings for brand
     * @summary Get warnings for brand
     * @param {BrandsApiGetBrandWarningsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    getBrandWarnings(requestParameters, options) {
        return BrandsApiFp(this.configuration).getBrandWarnings(requestParameters.brandId, requestParameters.nextToken, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Lock a brand
     * @summary Locks a brand
     * @param {BrandsApiLockBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    lockBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).lockBrand(requestParameters.brandId, requestParameters.brandLockRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * set the partner id on a brand
     * @summary a temporary endpoint to run a migration to set the partner id
     * @param {BrandsApiSetPartnerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    setPartnerId(requestParameters, options) {
        return BrandsApiFp(this.configuration).setPartnerId(requestParameters.brandId, requestParameters.setPartnerIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Unlock a brand
     * @summary Unlock a brand
     * @param {BrandsApiUnlockBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    unlockBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).unlockBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adds a user to a brand, or changes their role
     * @param {BrandsApiUpdateAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    updateAccess(requestParameters, options) {
        return BrandsApiFp(this.configuration).updateAccess(requestParameters.brandId, requestParameters.updateAccessRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a brand
     * @summary Update a brand
     * @param {BrandsApiUpdateBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    updateBrand(requestParameters, options) {
        return BrandsApiFp(this.configuration).updateBrand(requestParameters.brandId, requestParameters.updateBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a batch request for csv file to be uploaded for customer profiles
     * @summary Create a batch request for csv file to be uploaded for customer profiles
     * @param {BrandsApiUploadCustomerBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    uploadCustomerBatch(requestParameters, options) {
        return BrandsApiFp(this.configuration).uploadCustomerBatch(requestParameters.brandId, requestParameters.uploadCustomerBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the status for batch
     * @summary Update the status for batch
     * @param {BrandsApiUploadCustomerBatchStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    uploadCustomerBatchStatus(requestParameters, options) {
        return BrandsApiFp(this.configuration).uploadCustomerBatchStatus(requestParameters.brandId, requestParameters.batchId, requestParameters.uploadCustomerBatchStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update or create settings for a brand customer
     * @summary Update or create settings for a brand customer
     * @param {BrandsApiUpsertBrandCustomerSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    upsertBrandCustomerSettings(requestParameters, options) {
        return BrandsApiFp(this.configuration).upsertBrandCustomerSettings(requestParameters.brandId, requestParameters.upsertBrandCustomerSettings, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CreativesApi - axios parameter creator
 * @export
 */
export const CreativesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates a board
         * @summary Creates a board
         * @param {CreateAdBoardInput} createAdBoardInput parameters required to save ads to board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard: (createAdBoardInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createAdBoardInput' is not null or undefined
            assertParamExists('createBoard', 'createAdBoardInput', createAdBoardInput);
            const localVarPath = `/ads/creatives/board`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createAdBoardInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Remove ads from board
         * @summary Remove ads from board
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} adId ad ids delimited by comma
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdsFromBoard: (type, boardId, adId, ownerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('deleteAdsFromBoard', 'type', type);
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('deleteAdsFromBoard', 'boardId', boardId);
            // verify required parameter 'adId' is not null or undefined
            assertParamExists('deleteAdsFromBoard', 'adId', adId);
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('deleteAdsFromBoard', 'ownerId', ownerId);
            const localVarPath = `/ads/creatives/{type}/{ownerId}/board/{boardId}/ads`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (adId !== undefined) {
                localVarQueryParameter['adId'] = adId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get board of type
         * @summary Get board of type
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard: (type, boardId, ownerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getBoard', 'type', type);
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('getBoard', 'boardId', boardId);
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('getBoard', 'ownerId', ownerId);
            const localVarPath = `/ads/creatives/{type}/{ownerId}/board/{boardId}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get ads from board
         * @summary Get ads from board
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoardAds: (type, boardId, ownerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getBoardAds', 'type', type);
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('getBoardAds', 'boardId', boardId);
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('getBoardAds', 'ownerId', ownerId);
            const localVarPath = `/ads/creatives/{type}/{ownerId}/board/{boardId}/ads`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all boards of type
         * @summary Get all boards of type
         * @param {string} type board type
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoards: (type, ownerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getBoards', 'type', type);
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('getBoards', 'ownerId', ownerId);
            const localVarPath = `/ads/creatives/{type}/{ownerId}/board`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Save ads to board
         * @summary Save ads to board
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} ownerId owner id that owns all boards
         * @param {SaveAdsToBoardInput} saveAdsToBoardInput parameters required to save ads to board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdsToBoard: (type, boardId, ownerId, saveAdsToBoardInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('saveAdsToBoard', 'type', type);
            // verify required parameter 'boardId' is not null or undefined
            assertParamExists('saveAdsToBoard', 'boardId', boardId);
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('saveAdsToBoard', 'ownerId', ownerId);
            // verify required parameter 'saveAdsToBoardInput' is not null or undefined
            assertParamExists('saveAdsToBoard', 'saveAdsToBoardInput', saveAdsToBoardInput);
            const localVarPath = `/ads/creatives/{type}/{ownerId}/board/{boardId}/ads`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"boardId"}}`, encodeURIComponent(String(boardId)))
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveAdsToBoardInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CreativesApi - functional programming interface
 * @export
 */
export const CreativesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CreativesApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates a board
         * @summary Creates a board
         * @param {CreateAdBoardInput} createAdBoardInput parameters required to save ads to board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard(createAdBoardInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBoard(createAdBoardInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CreativesApi.createBoard']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Remove ads from board
         * @summary Remove ads from board
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} adId ad ids delimited by comma
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdsFromBoard(type, boardId, adId, ownerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAdsFromBoard(type, boardId, adId, ownerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CreativesApi.deleteAdsFromBoard']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get board of type
         * @summary Get board of type
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard(type, boardId, ownerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBoard(type, boardId, ownerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CreativesApi.getBoard']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get ads from board
         * @summary Get ads from board
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoardAds(type, boardId, ownerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBoardAds(type, boardId, ownerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CreativesApi.getBoardAds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all boards of type
         * @summary Get all boards of type
         * @param {string} type board type
         * @param {string} ownerId owner id that owns all boards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoards(type, ownerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBoards(type, ownerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CreativesApi.getBoards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Save ads to board
         * @summary Save ads to board
         * @param {string} type board type
         * @param {string} boardId board id
         * @param {string} ownerId owner id that owns all boards
         * @param {SaveAdsToBoardInput} saveAdsToBoardInput parameters required to save ads to board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdsToBoard(type, boardId, ownerId, saveAdsToBoardInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveAdsToBoard(type, boardId, ownerId, saveAdsToBoardInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CreativesApi.saveAdsToBoard']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * CreativesApi - factory interface
 * @export
 */
export const CreativesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CreativesApiFp(configuration);
    return {
        /**
         * Creates a board
         * @summary Creates a board
         * @param {CreativesApiCreateBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard(requestParameters, options) {
            return localVarFp.createBoard(requestParameters.createAdBoardInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove ads from board
         * @summary Remove ads from board
         * @param {CreativesApiDeleteAdsFromBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdsFromBoard(requestParameters, options) {
            return localVarFp.deleteAdsFromBoard(requestParameters.type, requestParameters.boardId, requestParameters.adId, requestParameters.ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get board of type
         * @summary Get board of type
         * @param {CreativesApiGetBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard(requestParameters, options) {
            return localVarFp.getBoard(requestParameters.type, requestParameters.boardId, requestParameters.ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ads from board
         * @summary Get ads from board
         * @param {CreativesApiGetBoardAdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoardAds(requestParameters, options) {
            return localVarFp.getBoardAds(requestParameters.type, requestParameters.boardId, requestParameters.ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all boards of type
         * @summary Get all boards of type
         * @param {CreativesApiGetBoardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoards(requestParameters, options) {
            return localVarFp.getBoards(requestParameters.type, requestParameters.ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Save ads to board
         * @summary Save ads to board
         * @param {CreativesApiSaveAdsToBoardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdsToBoard(requestParameters, options) {
            return localVarFp.saveAdsToBoard(requestParameters.type, requestParameters.boardId, requestParameters.ownerId, requestParameters.saveAdsToBoardInput, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CreativesApi - object-oriented interface
 * @export
 * @class CreativesApi
 * @extends {BaseAPI}
 */
export class CreativesApi extends BaseAPI {
    /**
     * Creates a board
     * @summary Creates a board
     * @param {CreativesApiCreateBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativesApi
     */
    createBoard(requestParameters, options) {
        return CreativesApiFp(this.configuration).createBoard(requestParameters.createAdBoardInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove ads from board
     * @summary Remove ads from board
     * @param {CreativesApiDeleteAdsFromBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativesApi
     */
    deleteAdsFromBoard(requestParameters, options) {
        return CreativesApiFp(this.configuration).deleteAdsFromBoard(requestParameters.type, requestParameters.boardId, requestParameters.adId, requestParameters.ownerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get board of type
     * @summary Get board of type
     * @param {CreativesApiGetBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativesApi
     */
    getBoard(requestParameters, options) {
        return CreativesApiFp(this.configuration).getBoard(requestParameters.type, requestParameters.boardId, requestParameters.ownerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get ads from board
     * @summary Get ads from board
     * @param {CreativesApiGetBoardAdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativesApi
     */
    getBoardAds(requestParameters, options) {
        return CreativesApiFp(this.configuration).getBoardAds(requestParameters.type, requestParameters.boardId, requestParameters.ownerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all boards of type
     * @summary Get all boards of type
     * @param {CreativesApiGetBoardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativesApi
     */
    getBoards(requestParameters, options) {
        return CreativesApiFp(this.configuration).getBoards(requestParameters.type, requestParameters.ownerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Save ads to board
     * @summary Save ads to board
     * @param {CreativesApiSaveAdsToBoardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreativesApi
     */
    saveAdsToBoard(requestParameters, options) {
        return CreativesApiFp(this.configuration).saveAdsToBoard(requestParameters.type, requestParameters.boardId, requestParameters.ownerId, requestParameters.saveAdsToBoardInput, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EntitlementsApi - axios parameter creator
 * @export
 */
export const EntitlementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gets all brand roles in system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves entitlements for backend services, used by Auth0
         * @param {ServiceEntitlementRequest} serviceEntitlementRequest access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceEntitlements: (serviceEntitlementRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serviceEntitlementRequest' is not null or undefined
            assertParamExists('getServiceEntitlements', 'serviceEntitlementRequest', serviceEntitlementRequest);
            const localVarPath = `/access/service/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(serviceEntitlementRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves entitlements a user has for a brand, used by Auth0
         * @param {UserEntitlementRequest} userEntitlementRequest access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEntitlements: (userEntitlementRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userEntitlementRequest' is not null or undefined
            assertParamExists('getUserEntitlements', 'userEntitlementRequest', userEntitlementRequest);
            const localVarPath = `/access/user/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userEntitlementRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EntitlementsApi - functional programming interface
 * @export
 */
export const EntitlementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EntitlementsApiAxiosParamCreator(configuration);
    return {
        /**
         * Gets all brand roles in system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoles(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['EntitlementsApi.getRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves entitlements for backend services, used by Auth0
         * @param {ServiceEntitlementRequest} serviceEntitlementRequest access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceEntitlements(serviceEntitlementRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getServiceEntitlements(serviceEntitlementRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['EntitlementsApi.getServiceEntitlements']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves entitlements a user has for a brand, used by Auth0
         * @param {UserEntitlementRequest} userEntitlementRequest access request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEntitlements(userEntitlementRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserEntitlements(userEntitlementRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['EntitlementsApi.getUserEntitlements']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * EntitlementsApi - factory interface
 * @export
 */
export const EntitlementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EntitlementsApiFp(configuration);
    return {
        /**
         * Gets all brand roles in system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(options) {
            return localVarFp.getRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves entitlements for backend services, used by Auth0
         * @param {EntitlementsApiGetServiceEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceEntitlements(requestParameters, options) {
            return localVarFp.getServiceEntitlements(requestParameters.serviceEntitlementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves entitlements a user has for a brand, used by Auth0
         * @param {EntitlementsApiGetUserEntitlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEntitlements(requestParameters, options) {
            return localVarFp.getUserEntitlements(requestParameters.userEntitlementRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EntitlementsApi - object-oriented interface
 * @export
 * @class EntitlementsApi
 * @extends {BaseAPI}
 */
export class EntitlementsApi extends BaseAPI {
    /**
     * Gets all brand roles in system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    getRoles(options) {
        return EntitlementsApiFp(this.configuration).getRoles(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves entitlements for backend services, used by Auth0
     * @param {EntitlementsApiGetServiceEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    getServiceEntitlements(requestParameters, options) {
        return EntitlementsApiFp(this.configuration).getServiceEntitlements(requestParameters.serviceEntitlementRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves entitlements a user has for a brand, used by Auth0
     * @param {EntitlementsApiGetUserEntitlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    getUserEntitlements(requestParameters, options) {
        return EntitlementsApiFp(this.configuration).getUserEntitlements(requestParameters.userEntitlementRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FbIntegrationApi - axios parameter creator
 * @export
 */
export const FbIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary checks for ad account terms of service, triggers fb api check
         * @param {string} brandId the id of the brand
         * @param {string} adAccountId the id of the ad account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAdAccountTos: (brandId, adAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('checkAdAccountTos', 'brandId', brandId);
            // verify required parameter 'adAccountId' is not null or undefined
            assertParamExists('checkAdAccountTos', 'adAccountId', adAccountId);
            const localVarPath = `/brand/{brandId}/fb/adAccount/{adAccountId}/tos`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"adAccountId"}}`, encodeURIComponent(String(adAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary checks if FB permissions are granted
         * @param {string} brandId the brand id
         * @param {CheckGrantedPermissionsRequest} checkGrantedPermissionsRequest parameters required to verify if permissions were granted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGrantedPermissions: (brandId, checkGrantedPermissionsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('checkGrantedPermissions', 'brandId', brandId);
            // verify required parameter 'checkGrantedPermissionsRequest' is not null or undefined
            assertParamExists('checkGrantedPermissions', 'checkGrantedPermissionsRequest', checkGrantedPermissionsRequest);
            const localVarPath = `/brand/{brandId}/integration/fb/permissions`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(checkGrantedPermissionsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary creates an ad account for brand
         * @param {string} brandId the id of the brand
         * @param {CreateBrandAdAccount} createBrandAdAccount parameters required to create the ad account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandAdAccount: (brandId, createBrandAdAccount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createBrandAdAccount', 'brandId', brandId);
            // verify required parameter 'createBrandAdAccount' is not null or undefined
            assertParamExists('createBrandAdAccount', 'createBrandAdAccount', createBrandAdAccount);
            const localVarPath = `/brand/{brandId}/fb/adAccount`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBrandAdAccount, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary creates a Facebook integration for brand
         * @param {string} brandId the brand id
         * @param {CreateFBIntegrationInput} createFBIntegrationInput parameters required to create the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFBIntegration: (brandId, createFBIntegrationInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createFBIntegration', 'brandId', brandId);
            // verify required parameter 'createFBIntegrationInput' is not null or undefined
            assertParamExists('createFBIntegration', 'createFBIntegrationInput', createFBIntegrationInput);
            const localVarPath = `/brand/{brandId}/integration/fb`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createFBIntegrationInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets ad accounts for brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccounts: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getAdAccounts', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/fb/adAccount`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all ad accounts from brandId list
         * @param {string} brandId the brand ids to batch ad accounts for, separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccountsBatch: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getAdAccountsBatch', 'brandId', brandId);
            const localVarPath = `/integration/fb/adAccount/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets all the fb ad accounts for a given master token
         * @param {GetAdAccountsMasterTokenRequest} getAdAccountsMasterTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccountsMasterToken: (getAdAccountsMasterTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getAdAccountsMasterTokenRequest' is not null or undefined
            assertParamExists('getAdAccountsMasterToken', 'getAdAccountsMasterTokenRequest', getAdAccountsMasterTokenRequest);
            const localVarPath = `/masterToken/adAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAdAccountsMasterTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets all ad accounts that are in use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdAccounts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integration/fb/adAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets an active ad account id and its integration id
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdAccount: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getCurrentAdAccount', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/fb/adAccount/current`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary refresh ad accounts for brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAdAccounts: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('refreshAdAccounts', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/fb/adAccount/refresh`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get adpixels from facebook and update db
         * @param {string} brandId the id of the brand
         * @param {string} adAccountId the id of the ad account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAdPixels: (brandId, adAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('refreshAdPixels', 'brandId', brandId);
            // verify required parameter 'adAccountId' is not null or undefined
            assertParamExists('refreshAdPixels', 'adAccountId', adAccountId);
            const localVarPath = `/brand/{brandId}/fb/adAccount/{adAccountId}/adPixel/refresh`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"adAccountId"}}`, encodeURIComponent(String(adAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary set the current ad account id for brand
         * @param {string} brandId the brandId of the user
         * @param {string} adAccountId the ad account id
         * @param {UpdateAdAccountInput} updateAdAccountInput fields to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdAccount: (brandId, adAccountId, updateAdAccountInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateAdAccount', 'brandId', brandId);
            // verify required parameter 'adAccountId' is not null or undefined
            assertParamExists('updateAdAccount', 'adAccountId', adAccountId);
            // verify required parameter 'updateAdAccountInput' is not null or undefined
            assertParamExists('updateAdAccount', 'updateAdAccountInput', updateAdAccountInput);
            const localVarPath = `/brand/{brandId}/fb/adAccount/{adAccountId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"adAccountId"}}`, encodeURIComponent(String(adAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdAccountInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FbIntegrationApi - functional programming interface
 * @export
 */
export const FbIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = FbIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary checks for ad account terms of service, triggers fb api check
         * @param {string} brandId the id of the brand
         * @param {string} adAccountId the id of the ad account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAdAccountTos(brandId, adAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkAdAccountTos(brandId, adAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.checkAdAccountTos']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary checks if FB permissions are granted
         * @param {string} brandId the brand id
         * @param {CheckGrantedPermissionsRequest} checkGrantedPermissionsRequest parameters required to verify if permissions were granted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGrantedPermissions(brandId, checkGrantedPermissionsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkGrantedPermissions(brandId, checkGrantedPermissionsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.checkGrantedPermissions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary creates an ad account for brand
         * @param {string} brandId the id of the brand
         * @param {CreateBrandAdAccount} createBrandAdAccount parameters required to create the ad account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandAdAccount(brandId, createBrandAdAccount, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBrandAdAccount(brandId, createBrandAdAccount, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.createBrandAdAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary creates a Facebook integration for brand
         * @param {string} brandId the brand id
         * @param {CreateFBIntegrationInput} createFBIntegrationInput parameters required to create the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFBIntegration(brandId, createFBIntegrationInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createFBIntegration(brandId, createFBIntegrationInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.createFBIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets ad accounts for brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccounts(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdAccounts(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.getAdAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary get all ad accounts from brandId list
         * @param {string} brandId the brand ids to batch ad accounts for, separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccountsBatch(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdAccountsBatch(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.getAdAccountsBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets all the fb ad accounts for a given master token
         * @param {GetAdAccountsMasterTokenRequest} getAdAccountsMasterTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccountsMasterToken(getAdAccountsMasterTokenRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdAccountsMasterToken(getAdAccountsMasterTokenRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.getAdAccountsMasterToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets all ad accounts that are in use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdAccounts(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllAdAccounts(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.getAllAdAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets an active ad account id and its integration id
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdAccount(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentAdAccount(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.getCurrentAdAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary refresh ad accounts for brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAdAccounts(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshAdAccounts(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.refreshAdAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary get adpixels from facebook and update db
         * @param {string} brandId the id of the brand
         * @param {string} adAccountId the id of the ad account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAdPixels(brandId, adAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshAdPixels(brandId, adAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.refreshAdPixels']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary set the current ad account id for brand
         * @param {string} brandId the brandId of the user
         * @param {string} adAccountId the ad account id
         * @param {UpdateAdAccountInput} updateAdAccountInput fields to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdAccount(brandId, adAccountId, updateAdAccountInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAdAccount(brandId, adAccountId, updateAdAccountInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['FbIntegrationApi.updateAdAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * FbIntegrationApi - factory interface
 * @export
 */
export const FbIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FbIntegrationApiFp(configuration);
    return {
        /**
         *
         * @summary checks for ad account terms of service, triggers fb api check
         * @param {FbIntegrationApiCheckAdAccountTosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAdAccountTos(requestParameters, options) {
            return localVarFp.checkAdAccountTos(requestParameters.brandId, requestParameters.adAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary checks if FB permissions are granted
         * @param {FbIntegrationApiCheckGrantedPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGrantedPermissions(requestParameters, options) {
            return localVarFp.checkGrantedPermissions(requestParameters.brandId, requestParameters.checkGrantedPermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary creates an ad account for brand
         * @param {FbIntegrationApiCreateBrandAdAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandAdAccount(requestParameters, options) {
            return localVarFp.createBrandAdAccount(requestParameters.brandId, requestParameters.createBrandAdAccount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary creates a Facebook integration for brand
         * @param {FbIntegrationApiCreateFBIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFBIntegration(requestParameters, options) {
            return localVarFp.createFBIntegration(requestParameters.brandId, requestParameters.createFBIntegrationInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets ad accounts for brand
         * @param {FbIntegrationApiGetAdAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccounts(requestParameters, options) {
            return localVarFp.getAdAccounts(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all ad accounts from brandId list
         * @param {FbIntegrationApiGetAdAccountsBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccountsBatch(requestParameters, options) {
            return localVarFp.getAdAccountsBatch(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets all the fb ad accounts for a given master token
         * @param {FbIntegrationApiGetAdAccountsMasterTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdAccountsMasterToken(requestParameters, options) {
            return localVarFp.getAdAccountsMasterToken(requestParameters.getAdAccountsMasterTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets all ad accounts that are in use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdAccounts(options) {
            return localVarFp.getAllAdAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets an active ad account id and its integration id
         * @param {FbIntegrationApiGetCurrentAdAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdAccount(requestParameters, options) {
            return localVarFp.getCurrentAdAccount(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary refresh ad accounts for brand
         * @param {FbIntegrationApiRefreshAdAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAdAccounts(requestParameters, options) {
            return localVarFp.refreshAdAccounts(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get adpixels from facebook and update db
         * @param {FbIntegrationApiRefreshAdPixelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAdPixels(requestParameters, options) {
            return localVarFp.refreshAdPixels(requestParameters.brandId, requestParameters.adAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary set the current ad account id for brand
         * @param {FbIntegrationApiUpdateAdAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdAccount(requestParameters, options) {
            return localVarFp.updateAdAccount(requestParameters.brandId, requestParameters.adAccountId, requestParameters.updateAdAccountInput, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FbIntegrationApi - object-oriented interface
 * @export
 * @class FbIntegrationApi
 * @extends {BaseAPI}
 */
export class FbIntegrationApi extends BaseAPI {
    /**
     *
     * @summary checks for ad account terms of service, triggers fb api check
     * @param {FbIntegrationApiCheckAdAccountTosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    checkAdAccountTos(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).checkAdAccountTos(requestParameters.brandId, requestParameters.adAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary checks if FB permissions are granted
     * @param {FbIntegrationApiCheckGrantedPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    checkGrantedPermissions(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).checkGrantedPermissions(requestParameters.brandId, requestParameters.checkGrantedPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary creates an ad account for brand
     * @param {FbIntegrationApiCreateBrandAdAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    createBrandAdAccount(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).createBrandAdAccount(requestParameters.brandId, requestParameters.createBrandAdAccount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary creates a Facebook integration for brand
     * @param {FbIntegrationApiCreateFBIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    createFBIntegration(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).createFBIntegration(requestParameters.brandId, requestParameters.createFBIntegrationInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets ad accounts for brand
     * @param {FbIntegrationApiGetAdAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    getAdAccounts(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).getAdAccounts(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all ad accounts from brandId list
     * @param {FbIntegrationApiGetAdAccountsBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    getAdAccountsBatch(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).getAdAccountsBatch(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets all the fb ad accounts for a given master token
     * @param {FbIntegrationApiGetAdAccountsMasterTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    getAdAccountsMasterToken(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).getAdAccountsMasterToken(requestParameters.getAdAccountsMasterTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets all ad accounts that are in use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    getAllAdAccounts(options) {
        return FbIntegrationApiFp(this.configuration).getAllAdAccounts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets an active ad account id and its integration id
     * @param {FbIntegrationApiGetCurrentAdAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    getCurrentAdAccount(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).getCurrentAdAccount(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary refresh ad accounts for brand
     * @param {FbIntegrationApiRefreshAdAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    refreshAdAccounts(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).refreshAdAccounts(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get adpixels from facebook and update db
     * @param {FbIntegrationApiRefreshAdPixelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    refreshAdPixels(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).refreshAdPixels(requestParameters.brandId, requestParameters.adAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary set the current ad account id for brand
     * @param {FbIntegrationApiUpdateAdAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FbIntegrationApi
     */
    updateAdAccount(requestParameters, options) {
        return FbIntegrationApiFp(this.configuration).updateAdAccount(requestParameters.brandId, requestParameters.adAccountId, requestParameters.updateAdAccountInput, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IntegrationSyncStateApi - axios parameter creator
 * @export
 */
export const IntegrationSyncStateApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * retrieves an integration sync state
         * @summary retrieves integration sync state
         * @param {string} integrationId Id of integration
         * @param {string} tenantId Id of tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIntegrationSyncState: (integrationId, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('fetchIntegrationSyncState', 'integrationId', integrationId);
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('fetchIntegrationSyncState', 'tenantId', tenantId);
            const localVarPath = `/integration/{integrationId}/tenant/{tenantId}/state`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * retrieves an integration sync state for a brand
         * @summary retrieves sync state
         * @param {string} brandId brand ID
         * @param {FetchSyncStateIntegrationTypeEnum} integrationType type of integration
         * @param {string} syncStateId ad account id provided by FB (this might change in the future)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSyncState: (brandId, integrationType, syncStateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('fetchSyncState', 'brandId', brandId);
            // verify required parameter 'integrationType' is not null or undefined
            assertParamExists('fetchSyncState', 'integrationType', integrationType);
            // verify required parameter 'syncStateId' is not null or undefined
            assertParamExists('fetchSyncState', 'syncStateId', syncStateId);
            const localVarPath = `/brand/{brandId}/integration/{integrationType}/state/{syncStateId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationType"}}`, encodeURIComponent(String(integrationType)))
                .replace(`{${"syncStateId"}}`, encodeURIComponent(String(syncStateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * retrieves an integration sync state for a brand
         * @summary retrieves sync state
         * @param {string} brandId brand ID
         * @param {GetLastUpdateIntegrationTypeEnum} integrationType type of integration
         * @param {string} syncStateId ad account id provided by FB (this might change in the future)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUpdate: (brandId, integrationType, syncStateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getLastUpdate', 'brandId', brandId);
            // verify required parameter 'integrationType' is not null or undefined
            assertParamExists('getLastUpdate', 'integrationType', integrationType);
            // verify required parameter 'syncStateId' is not null or undefined
            assertParamExists('getLastUpdate', 'syncStateId', syncStateId);
            const localVarPath = `/brand/{brandId}/integration/{integrationType}/state/{syncStateId}/last-update`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationType"}}`, encodeURIComponent(String(integrationType)))
                .replace(`{${"syncStateId"}}`, encodeURIComponent(String(syncStateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates/Updates sync state
         * @summary Creates/Updates sync state
         * @param {string} brandId brand ID
         * @param {UpdateSyncStateIntegrationTypeEnum} integrationType type of integration
         * @param {string} syncStateId ad account id provided by FB (this might change in the future)
         * @param {SyncState} syncState Sync state to create/update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncState: (brandId, integrationType, syncStateId, syncState, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateSyncState', 'brandId', brandId);
            // verify required parameter 'integrationType' is not null or undefined
            assertParamExists('updateSyncState', 'integrationType', integrationType);
            // verify required parameter 'syncStateId' is not null or undefined
            assertParamExists('updateSyncState', 'syncStateId', syncStateId);
            // verify required parameter 'syncState' is not null or undefined
            assertParamExists('updateSyncState', 'syncState', syncState);
            const localVarPath = `/brand/{brandId}/integration/{integrationType}/state/{syncStateId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationType"}}`, encodeURIComponent(String(integrationType)))
                .replace(`{${"syncStateId"}}`, encodeURIComponent(String(syncStateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(syncState, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates/Updates sync state
         * @summary Creates/Updates sync integration state for non brands
         * @param {string} integrationId integrationId
         * @param {string} tenantId Id of tenant. Every integration comes with unique way of providing access and managing its business/consumers/users data. Each one may use a different terminology for identify, for example accounts/addAccounts/user/client. More specifically in our case its Facebook has AdAccounts, Shopify has Stores. So, a generic name of tenant was given to identify the unique consumer of respective integration and manage the state of same.
         * @param {SyncIntegrationState} syncIntegrationState Sync  integration state to create/update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIntegrationSyncState: (integrationId, tenantId, syncIntegrationState, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('upsertIntegrationSyncState', 'integrationId', integrationId);
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('upsertIntegrationSyncState', 'tenantId', tenantId);
            // verify required parameter 'syncIntegrationState' is not null or undefined
            assertParamExists('upsertIntegrationSyncState', 'syncIntegrationState', syncIntegrationState);
            const localVarPath = `/integration/{integrationId}/tenant/{tenantId}/state`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)))
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(syncIntegrationState, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * IntegrationSyncStateApi - functional programming interface
 * @export
 */
export const IntegrationSyncStateApiFp = function (configuration) {
    const localVarAxiosParamCreator = IntegrationSyncStateApiAxiosParamCreator(configuration);
    return {
        /**
         * retrieves an integration sync state
         * @summary retrieves integration sync state
         * @param {string} integrationId Id of integration
         * @param {string} tenantId Id of tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIntegrationSyncState(integrationId, tenantId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchIntegrationSyncState(integrationId, tenantId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationSyncStateApi.fetchIntegrationSyncState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * retrieves an integration sync state for a brand
         * @summary retrieves sync state
         * @param {string} brandId brand ID
         * @param {FetchSyncStateIntegrationTypeEnum} integrationType type of integration
         * @param {string} syncStateId ad account id provided by FB (this might change in the future)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSyncState(brandId, integrationType, syncStateId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchSyncState(brandId, integrationType, syncStateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationSyncStateApi.fetchSyncState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * retrieves an integration sync state for a brand
         * @summary retrieves sync state
         * @param {string} brandId brand ID
         * @param {GetLastUpdateIntegrationTypeEnum} integrationType type of integration
         * @param {string} syncStateId ad account id provided by FB (this might change in the future)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUpdate(brandId, integrationType, syncStateId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLastUpdate(brandId, integrationType, syncStateId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationSyncStateApi.getLastUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates/Updates sync state
         * @summary Creates/Updates sync state
         * @param {string} brandId brand ID
         * @param {UpdateSyncStateIntegrationTypeEnum} integrationType type of integration
         * @param {string} syncStateId ad account id provided by FB (this might change in the future)
         * @param {SyncState} syncState Sync state to create/update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncState(brandId, integrationType, syncStateId, syncState, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSyncState(brandId, integrationType, syncStateId, syncState, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationSyncStateApi.updateSyncState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Creates/Updates sync state
         * @summary Creates/Updates sync integration state for non brands
         * @param {string} integrationId integrationId
         * @param {string} tenantId Id of tenant. Every integration comes with unique way of providing access and managing its business/consumers/users data. Each one may use a different terminology for identify, for example accounts/addAccounts/user/client. More specifically in our case its Facebook has AdAccounts, Shopify has Stores. So, a generic name of tenant was given to identify the unique consumer of respective integration and manage the state of same.
         * @param {SyncIntegrationState} syncIntegrationState Sync  integration state to create/update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIntegrationSyncState(integrationId, tenantId, syncIntegrationState, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertIntegrationSyncState(integrationId, tenantId, syncIntegrationState, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationSyncStateApi.upsertIntegrationSyncState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * IntegrationSyncStateApi - factory interface
 * @export
 */
export const IntegrationSyncStateApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IntegrationSyncStateApiFp(configuration);
    return {
        /**
         * retrieves an integration sync state
         * @summary retrieves integration sync state
         * @param {IntegrationSyncStateApiFetchIntegrationSyncStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIntegrationSyncState(requestParameters, options) {
            return localVarFp.fetchIntegrationSyncState(requestParameters.integrationId, requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves an integration sync state for a brand
         * @summary retrieves sync state
         * @param {IntegrationSyncStateApiFetchSyncStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchSyncState(requestParameters, options) {
            return localVarFp.fetchSyncState(requestParameters.brandId, requestParameters.integrationType, requestParameters.syncStateId, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves an integration sync state for a brand
         * @summary retrieves sync state
         * @param {IntegrationSyncStateApiGetLastUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUpdate(requestParameters, options) {
            return localVarFp.getLastUpdate(requestParameters.brandId, requestParameters.integrationType, requestParameters.syncStateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates/Updates sync state
         * @summary Creates/Updates sync state
         * @param {IntegrationSyncStateApiUpdateSyncStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncState(requestParameters, options) {
            return localVarFp.updateSyncState(requestParameters.brandId, requestParameters.integrationType, requestParameters.syncStateId, requestParameters.syncState, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates/Updates sync state
         * @summary Creates/Updates sync integration state for non brands
         * @param {IntegrationSyncStateApiUpsertIntegrationSyncStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIntegrationSyncState(requestParameters, options) {
            return localVarFp.upsertIntegrationSyncState(requestParameters.integrationId, requestParameters.tenantId, requestParameters.syncIntegrationState, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IntegrationSyncStateApi - object-oriented interface
 * @export
 * @class IntegrationSyncStateApi
 * @extends {BaseAPI}
 */
export class IntegrationSyncStateApi extends BaseAPI {
    /**
     * retrieves an integration sync state
     * @summary retrieves integration sync state
     * @param {IntegrationSyncStateApiFetchIntegrationSyncStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSyncStateApi
     */
    fetchIntegrationSyncState(requestParameters, options) {
        return IntegrationSyncStateApiFp(this.configuration).fetchIntegrationSyncState(requestParameters.integrationId, requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * retrieves an integration sync state for a brand
     * @summary retrieves sync state
     * @param {IntegrationSyncStateApiFetchSyncStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSyncStateApi
     */
    fetchSyncState(requestParameters, options) {
        return IntegrationSyncStateApiFp(this.configuration).fetchSyncState(requestParameters.brandId, requestParameters.integrationType, requestParameters.syncStateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * retrieves an integration sync state for a brand
     * @summary retrieves sync state
     * @param {IntegrationSyncStateApiGetLastUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSyncStateApi
     */
    getLastUpdate(requestParameters, options) {
        return IntegrationSyncStateApiFp(this.configuration).getLastUpdate(requestParameters.brandId, requestParameters.integrationType, requestParameters.syncStateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates/Updates sync state
     * @summary Creates/Updates sync state
     * @param {IntegrationSyncStateApiUpdateSyncStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSyncStateApi
     */
    updateSyncState(requestParameters, options) {
        return IntegrationSyncStateApiFp(this.configuration).updateSyncState(requestParameters.brandId, requestParameters.integrationType, requestParameters.syncStateId, requestParameters.syncState, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates/Updates sync state
     * @summary Creates/Updates sync integration state for non brands
     * @param {IntegrationSyncStateApiUpsertIntegrationSyncStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationSyncStateApi
     */
    upsertIntegrationSyncState(requestParameters, options) {
        return IntegrationSyncStateApiFp(this.configuration).upsertIntegrationSyncState(requestParameters.integrationId, requestParameters.tenantId, requestParameters.syncIntegrationState, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const FetchSyncStateIntegrationTypeEnum = {
    Facebook: 'facebook',
    Klaviyo: 'klaviyo'
};
/**
 * @export
 */
export const GetLastUpdateIntegrationTypeEnum = {
    Facebook: 'facebook',
    Klaviyo: 'klaviyo'
};
/**
 * @export
 */
export const UpdateSyncStateIntegrationTypeEnum = {
    Facebook: 'facebook',
    Klaviyo: 'klaviyo'
};
/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
export const IntegrationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary creates integration for brand
         * @param {string} brandId the brandId of the user
         * @param {CreateIntegrationRequest} createIntegrationRequest create integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegration: (brandId, createIntegrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createIntegration', 'brandId', brandId);
            // verify required parameter 'createIntegrationRequest' is not null or undefined
            assertParamExists('createIntegration', 'createIntegrationRequest', createIntegrationRequest);
            const localVarPath = `/brand/{brandId}/integration`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createIntegrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary creates integration for orphan(without brand)
         * @param {CreateIntegrationRequest} createIntegrationRequest integration payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationOrphan: (createIntegrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createIntegrationRequest' is not null or undefined
            assertParamExists('createIntegrationOrphan', 'createIntegrationRequest', createIntegrationRequest);
            const localVarPath = `/integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createIntegrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary creates master token
         * @param {CreateMasterTokenRequest} createMasterTokenRequest create master token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterToken: (createMasterTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMasterTokenRequest' is not null or undefined
            assertParamExists('createMasterToken', 'createMasterTokenRequest', createMasterTokenRequest);
            const localVarPath = `/masterToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createMasterTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary creates integration for brand with master token
         * @param {string} brandId the brandId of the user
         * @param {CreateMasterIntegrationRequest} createMasterIntegrationRequest create integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterTokenIntegration: (brandId, createMasterIntegrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createMasterTokenIntegration', 'brandId', brandId);
            // verify required parameter 'createMasterIntegrationRequest' is not null or undefined
            assertParamExists('createMasterTokenIntegration', 'createMasterIntegrationRequest', createMasterIntegrationRequest);
            const localVarPath = `/brand/{brandId}/masterToken/integration`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createMasterIntegrationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary deletes an integration for a brand
         * @param {string} brandId the id of the brand
         * @param {string} integrationId the id of the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegration: (brandId, integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteIntegration', 'brandId', brandId);
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('deleteIntegration', 'integrationId', integrationId);
            const localVarPath = `/brand/{brandId}/integration/{integrationId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary query active master token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMasterToken: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/masterToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary query all integrations
         * @param {string} [integrationIds] comma delimited list of integration ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIntegrations: (integrationIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (integrationIds !== undefined) {
                localVarQueryParameter['integrationIds'] = integrationIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets integration token (data science)
         * @param {string} integrationId integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecryptedToken: (integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getDecryptedToken', 'integrationId', integrationId);
            const localVarPath = `/integration/{integrationId}/token`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary fetch an integration for a brand
         * @param {string} brandId the id of the brand
         * @param {string} integrationId the id of the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegration: (brandId, integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getIntegration', 'brandId', brandId);
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getIntegration', 'integrationId', integrationId);
            const localVarPath = `/brand/{brandId}/integration/{integrationId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary query integrations
         * @param {string} [brandId] comma delimited list of brand ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integration/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets all integrations for a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsForBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getIntegrationsForBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/integration`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary query integrations
         * @param {string} [brandId] comma delimited list of brand ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsHistory: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integration/batch/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary fetch integration history for a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsHistoryForBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getIntegrationsHistoryForBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/integration/history`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary query active master token map by brand id
         * @param {string} brandId the brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterTokenBrandMap: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getMasterTokenBrandMap', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/masterToken/map`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * IntegrationsApi - functional programming interface
 * @export
 */
export const IntegrationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = IntegrationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary creates integration for brand
         * @param {string} brandId the brandId of the user
         * @param {CreateIntegrationRequest} createIntegrationRequest create integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegration(brandId, createIntegrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createIntegration(brandId, createIntegrationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.createIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary creates integration for orphan(without brand)
         * @param {CreateIntegrationRequest} createIntegrationRequest integration payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationOrphan(createIntegrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createIntegrationOrphan(createIntegrationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.createIntegrationOrphan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary creates master token
         * @param {CreateMasterTokenRequest} createMasterTokenRequest create master token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterToken(createMasterTokenRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMasterToken(createMasterTokenRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.createMasterToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary creates integration for brand with master token
         * @param {string} brandId the brandId of the user
         * @param {CreateMasterIntegrationRequest} createMasterIntegrationRequest create integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterTokenIntegration(brandId, createMasterIntegrationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMasterTokenIntegration(brandId, createMasterIntegrationRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.createMasterTokenIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary deletes an integration for a brand
         * @param {string} brandId the id of the brand
         * @param {string} integrationId the id of the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegration(brandId, integrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteIntegration(brandId, integrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.deleteIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary query active master token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMasterToken(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveMasterToken(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getActiveMasterToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary query all integrations
         * @param {string} [integrationIds] comma delimited list of integration ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIntegrations(integrationIds, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllIntegrations(integrationIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getAllIntegrations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets integration token (data science)
         * @param {string} integrationId integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecryptedToken(integrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDecryptedToken(integrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getDecryptedToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary fetch an integration for a brand
         * @param {string} brandId the id of the brand
         * @param {string} integrationId the id of the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegration(brandId, integrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIntegration(brandId, integrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary query integrations
         * @param {string} [brandId] comma delimited list of brand ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIntegrations(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getIntegrations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets all integrations for a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsForBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIntegrationsForBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getIntegrationsForBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary query integrations
         * @param {string} [brandId] comma delimited list of brand ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsHistory(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIntegrationsHistory(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getIntegrationsHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary fetch integration history for a brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsHistoryForBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIntegrationsHistoryForBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getIntegrationsHistoryForBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary query active master token map by brand id
         * @param {string} brandId the brandId of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterTokenBrandMap(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMasterTokenBrandMap(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntegrationsApi.getMasterTokenBrandMap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * IntegrationsApi - factory interface
 * @export
 */
export const IntegrationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IntegrationsApiFp(configuration);
    return {
        /**
         *
         * @summary creates integration for brand
         * @param {IntegrationsApiCreateIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegration(requestParameters, options) {
            return localVarFp.createIntegration(requestParameters.brandId, requestParameters.createIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary creates integration for orphan(without brand)
         * @param {IntegrationsApiCreateIntegrationOrphanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationOrphan(requestParameters, options) {
            return localVarFp.createIntegrationOrphan(requestParameters.createIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary creates master token
         * @param {IntegrationsApiCreateMasterTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterToken(requestParameters, options) {
            return localVarFp.createMasterToken(requestParameters.createMasterTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary creates integration for brand with master token
         * @param {IntegrationsApiCreateMasterTokenIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterTokenIntegration(requestParameters, options) {
            return localVarFp.createMasterTokenIntegration(requestParameters.brandId, requestParameters.createMasterIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary deletes an integration for a brand
         * @param {IntegrationsApiDeleteIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIntegration(requestParameters, options) {
            return localVarFp.deleteIntegration(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary query active master token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMasterToken(options) {
            return localVarFp.getActiveMasterToken(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary query all integrations
         * @param {IntegrationsApiGetAllIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIntegrations(requestParameters = {}, options) {
            return localVarFp.getAllIntegrations(requestParameters.integrationIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets integration token (data science)
         * @param {IntegrationsApiGetDecryptedTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecryptedToken(requestParameters, options) {
            return localVarFp.getDecryptedToken(requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary fetch an integration for a brand
         * @param {IntegrationsApiGetIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegration(requestParameters, options) {
            return localVarFp.getIntegration(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary query integrations
         * @param {IntegrationsApiGetIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrations(requestParameters = {}, options) {
            return localVarFp.getIntegrations(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets all integrations for a brand
         * @param {IntegrationsApiGetIntegrationsForBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsForBrand(requestParameters, options) {
            return localVarFp.getIntegrationsForBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary query integrations
         * @param {IntegrationsApiGetIntegrationsHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsHistory(requestParameters = {}, options) {
            return localVarFp.getIntegrationsHistory(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary fetch integration history for a brand
         * @param {IntegrationsApiGetIntegrationsHistoryForBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsHistoryForBrand(requestParameters, options) {
            return localVarFp.getIntegrationsHistoryForBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary query active master token map by brand id
         * @param {IntegrationsApiGetMasterTokenBrandMapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterTokenBrandMap(requestParameters, options) {
            return localVarFp.getMasterTokenBrandMap(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
export class IntegrationsApi extends BaseAPI {
    /**
     *
     * @summary creates integration for brand
     * @param {IntegrationsApiCreateIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    createIntegration(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).createIntegration(requestParameters.brandId, requestParameters.createIntegrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary creates integration for orphan(without brand)
     * @param {IntegrationsApiCreateIntegrationOrphanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    createIntegrationOrphan(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).createIntegrationOrphan(requestParameters.createIntegrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary creates master token
     * @param {IntegrationsApiCreateMasterTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    createMasterToken(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).createMasterToken(requestParameters.createMasterTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary creates integration for brand with master token
     * @param {IntegrationsApiCreateMasterTokenIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    createMasterTokenIntegration(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).createMasterTokenIntegration(requestParameters.brandId, requestParameters.createMasterIntegrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary deletes an integration for a brand
     * @param {IntegrationsApiDeleteIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    deleteIntegration(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).deleteIntegration(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary query active master token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getActiveMasterToken(options) {
        return IntegrationsApiFp(this.configuration).getActiveMasterToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary query all integrations
     * @param {IntegrationsApiGetAllIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getAllIntegrations(requestParameters = {}, options) {
        return IntegrationsApiFp(this.configuration).getAllIntegrations(requestParameters.integrationIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets integration token (data science)
     * @param {IntegrationsApiGetDecryptedTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getDecryptedToken(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).getDecryptedToken(requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary fetch an integration for a brand
     * @param {IntegrationsApiGetIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getIntegration(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).getIntegration(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary query integrations
     * @param {IntegrationsApiGetIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getIntegrations(requestParameters = {}, options) {
        return IntegrationsApiFp(this.configuration).getIntegrations(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets all integrations for a brand
     * @param {IntegrationsApiGetIntegrationsForBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getIntegrationsForBrand(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).getIntegrationsForBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary query integrations
     * @param {IntegrationsApiGetIntegrationsHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getIntegrationsHistory(requestParameters = {}, options) {
        return IntegrationsApiFp(this.configuration).getIntegrationsHistory(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary fetch integration history for a brand
     * @param {IntegrationsApiGetIntegrationsHistoryForBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getIntegrationsHistoryForBrand(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).getIntegrationsHistoryForBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary query active master token map by brand id
     * @param {IntegrationsApiGetMasterTokenBrandMapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    getMasterTokenBrandMap(requestParameters, options) {
        return IntegrationsApiFp(this.configuration).getMasterTokenBrandMap(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IntelligenceApi - axios parameter creator
 * @export
 */
export const IntelligenceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get insight data for a brand and ad account given a metric
         * @summary Get insight data for a brand and ad account given a metric
         * @param {string} brandId The brand ID
         * @param {string} adAccountId The ad account ID
         * @param {string} metric The metric
         * @param {GetBrandInsightsIntervalEnum} [interval] The date interval
         * @param {string} [startDate] The start date
         * @param {string} [endDate] The end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandInsights: (brandId, adAccountId, metric, interval, startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrandInsights', 'brandId', brandId);
            // verify required parameter 'adAccountId' is not null or undefined
            assertParamExists('getBrandInsights', 'adAccountId', adAccountId);
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getBrandInsights', 'metric', metric);
            const localVarPath = `/brand/{brandId}/fb/adAccount/{adAccountId}/insight/{metric}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"adAccountId"}}`, encodeURIComponent(String(adAccountId)))
                .replace(`{${"metric"}}`, encodeURIComponent(String(metric)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (interval !== undefined) {
                localVarQueryParameter['interval'] = interval;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get insight data for a flavor category given a metric
         * @summary Get insight data for a flavor category given a metric
         * @param {string} flavorCategoryId The brand\&#39;s flavor category ID
         * @param {string} metric The metric
         * @param {string} [anchorMetric] The performance anchor metric. Defaults to &#x60;metric&#x60; value if not provided.
         * @param {GetFlavorCategoryInsightsIntervalEnum} [interval] The date interval
         * @param {string} [startDate] The start date
         * @param {string} [endDate] The end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlavorCategoryInsights: (flavorCategoryId, metric, anchorMetric, interval, startDate, endDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'flavorCategoryId' is not null or undefined
            assertParamExists('getFlavorCategoryInsights', 'flavorCategoryId', flavorCategoryId);
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getFlavorCategoryInsights', 'metric', metric);
            const localVarPath = `/flavor-category/{flavorCategoryId}/insight/{metric}`
                .replace(`{${"flavorCategoryId"}}`, encodeURIComponent(String(flavorCategoryId)))
                .replace(`{${"metric"}}`, encodeURIComponent(String(metric)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (anchorMetric !== undefined) {
                localVarQueryParameter['anchorMetric'] = anchorMetric;
            }
            if (interval !== undefined) {
                localVarQueryParameter['interval'] = interval;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * IntelligenceApi - functional programming interface
 * @export
 */
export const IntelligenceApiFp = function (configuration) {
    const localVarAxiosParamCreator = IntelligenceApiAxiosParamCreator(configuration);
    return {
        /**
         * Get insight data for a brand and ad account given a metric
         * @summary Get insight data for a brand and ad account given a metric
         * @param {string} brandId The brand ID
         * @param {string} adAccountId The ad account ID
         * @param {string} metric The metric
         * @param {GetBrandInsightsIntervalEnum} [interval] The date interval
         * @param {string} [startDate] The start date
         * @param {string} [endDate] The end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandInsights(brandId, adAccountId, metric, interval, startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandInsights(brandId, adAccountId, metric, interval, startDate, endDate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntelligenceApi.getBrandInsights']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get insight data for a flavor category given a metric
         * @summary Get insight data for a flavor category given a metric
         * @param {string} flavorCategoryId The brand\&#39;s flavor category ID
         * @param {string} metric The metric
         * @param {string} [anchorMetric] The performance anchor metric. Defaults to &#x60;metric&#x60; value if not provided.
         * @param {GetFlavorCategoryInsightsIntervalEnum} [interval] The date interval
         * @param {string} [startDate] The start date
         * @param {string} [endDate] The end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlavorCategoryInsights(flavorCategoryId, metric, anchorMetric, interval, startDate, endDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFlavorCategoryInsights(flavorCategoryId, metric, anchorMetric, interval, startDate, endDate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['IntelligenceApi.getFlavorCategoryInsights']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * IntelligenceApi - factory interface
 * @export
 */
export const IntelligenceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IntelligenceApiFp(configuration);
    return {
        /**
         * Get insight data for a brand and ad account given a metric
         * @summary Get insight data for a brand and ad account given a metric
         * @param {IntelligenceApiGetBrandInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandInsights(requestParameters, options) {
            return localVarFp.getBrandInsights(requestParameters.brandId, requestParameters.adAccountId, requestParameters.metric, requestParameters.interval, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get insight data for a flavor category given a metric
         * @summary Get insight data for a flavor category given a metric
         * @param {IntelligenceApiGetFlavorCategoryInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlavorCategoryInsights(requestParameters, options) {
            return localVarFp.getFlavorCategoryInsights(requestParameters.flavorCategoryId, requestParameters.metric, requestParameters.anchorMetric, requestParameters.interval, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IntelligenceApi - object-oriented interface
 * @export
 * @class IntelligenceApi
 * @extends {BaseAPI}
 */
export class IntelligenceApi extends BaseAPI {
    /**
     * Get insight data for a brand and ad account given a metric
     * @summary Get insight data for a brand and ad account given a metric
     * @param {IntelligenceApiGetBrandInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntelligenceApi
     */
    getBrandInsights(requestParameters, options) {
        return IntelligenceApiFp(this.configuration).getBrandInsights(requestParameters.brandId, requestParameters.adAccountId, requestParameters.metric, requestParameters.interval, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get insight data for a flavor category given a metric
     * @summary Get insight data for a flavor category given a metric
     * @param {IntelligenceApiGetFlavorCategoryInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntelligenceApi
     */
    getFlavorCategoryInsights(requestParameters, options) {
        return IntelligenceApiFp(this.configuration).getFlavorCategoryInsights(requestParameters.flavorCategoryId, requestParameters.metric, requestParameters.anchorMetric, requestParameters.interval, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const GetBrandInsightsIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
/**
 * @export
 */
export const GetFlavorCategoryInsightsIntervalEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
/**
 * KlaviyoIntegrationApi - axios parameter creator
 * @export
 */
export const KlaviyoIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary creates a Klaviyo integration for a brand
         * @param {string} brandId the brand id
         * @param {CreateKlaviyoIntegrationInput} createKlaviyoIntegrationInput parameters required to create the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKlaviyoIntegration: (brandId, createKlaviyoIntegrationInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createKlaviyoIntegration', 'brandId', brandId);
            // verify required parameter 'createKlaviyoIntegrationInput' is not null or undefined
            assertParamExists('createKlaviyoIntegration', 'createKlaviyoIntegrationInput', createKlaviyoIntegrationInput);
            const localVarPath = `/brand/{brandId}/integration/klaviyo`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createKlaviyoIntegrationInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets klaviyo masked api key
         * @param {string} brandId brand id
         * @param {string} integrationId integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskedKlaviyoToken: (brandId, integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getMaskedKlaviyoToken', 'brandId', brandId);
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getMaskedKlaviyoToken', 'integrationId', integrationId);
            const localVarPath = `/brand/{brandId}/klaviyo/{integrationId}/token`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * KlaviyoIntegrationApi - functional programming interface
 * @export
 */
export const KlaviyoIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = KlaviyoIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary creates a Klaviyo integration for a brand
         * @param {string} brandId the brand id
         * @param {CreateKlaviyoIntegrationInput} createKlaviyoIntegrationInput parameters required to create the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKlaviyoIntegration(brandId, createKlaviyoIntegrationInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createKlaviyoIntegration(brandId, createKlaviyoIntegrationInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['KlaviyoIntegrationApi.createKlaviyoIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets klaviyo masked api key
         * @param {string} brandId brand id
         * @param {string} integrationId integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskedKlaviyoToken(brandId, integrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMaskedKlaviyoToken(brandId, integrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['KlaviyoIntegrationApi.getMaskedKlaviyoToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * KlaviyoIntegrationApi - factory interface
 * @export
 */
export const KlaviyoIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = KlaviyoIntegrationApiFp(configuration);
    return {
        /**
         *
         * @summary creates a Klaviyo integration for a brand
         * @param {KlaviyoIntegrationApiCreateKlaviyoIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKlaviyoIntegration(requestParameters, options) {
            return localVarFp.createKlaviyoIntegration(requestParameters.brandId, requestParameters.createKlaviyoIntegrationInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets klaviyo masked api key
         * @param {KlaviyoIntegrationApiGetMaskedKlaviyoTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaskedKlaviyoToken(requestParameters, options) {
            return localVarFp.getMaskedKlaviyoToken(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * KlaviyoIntegrationApi - object-oriented interface
 * @export
 * @class KlaviyoIntegrationApi
 * @extends {BaseAPI}
 */
export class KlaviyoIntegrationApi extends BaseAPI {
    /**
     *
     * @summary creates a Klaviyo integration for a brand
     * @param {KlaviyoIntegrationApiCreateKlaviyoIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KlaviyoIntegrationApi
     */
    createKlaviyoIntegration(requestParameters, options) {
        return KlaviyoIntegrationApiFp(this.configuration).createKlaviyoIntegration(requestParameters.brandId, requestParameters.createKlaviyoIntegrationInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets klaviyo masked api key
     * @param {KlaviyoIntegrationApiGetMaskedKlaviyoTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KlaviyoIntegrationApi
     */
    getMaskedKlaviyoToken(requestParameters, options) {
        return KlaviyoIntegrationApiFp(this.configuration).getMaskedKlaviyoToken(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PartnersApi - axios parameter creator
 * @export
 */
export const PartnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a partner
         * @summary Create a partner
         * @param {CreatePartnerRequest} createPartnerRequest Partner to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: (createPartnerRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPartnerRequest' is not null or undefined
            assertParamExists('createPartner', 'createPartnerRequest', createPartnerRequest);
            const localVarPath = `/partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all partners
         * @summary Get all partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPartners: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get partner by id
         * @summary Get partner by id
         * @param {string} partnerId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerById: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPartnerById', 'partnerId', partnerId);
            const localVarPath = `/partner/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get partner by name
         * @summary Get partner by name
         * @param {string} partnerName name of a partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerByName: (partnerName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerName' is not null or undefined
            assertParamExists('getPartnerByName', 'partnerName', partnerName);
            const localVarPath = `/partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (partnerName !== undefined) {
                localVarQueryParameter['partnerName'] = partnerName;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartnersApi - functional programming interface
 * @export
 */
export const PartnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a partner
         * @summary Create a partner
         * @param {CreatePartnerRequest} createPartnerRequest Partner to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(createPartnerRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPartner(createPartnerRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PartnersApi.createPartner']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all partners
         * @summary Get all partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPartners(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllPartners(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PartnersApi.getAllPartners']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get partner by id
         * @summary Get partner by id
         * @param {string} partnerId id of brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerById(partnerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerById(partnerId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PartnersApi.getPartnerById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get partner by name
         * @summary Get partner by name
         * @param {string} partnerName name of a partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerByName(partnerName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerByName(partnerName, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['PartnersApi.getPartnerByName']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * PartnersApi - factory interface
 * @export
 */
export const PartnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PartnersApiFp(configuration);
    return {
        /**
         * Create a partner
         * @summary Create a partner
         * @param {PartnersApiCreatePartnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(requestParameters, options) {
            return localVarFp.createPartner(requestParameters.createPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all partners
         * @summary Get all partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPartners(options) {
            return localVarFp.getAllPartners(options).then((request) => request(axios, basePath));
        },
        /**
         * Get partner by id
         * @summary Get partner by id
         * @param {PartnersApiGetPartnerByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerById(requestParameters, options) {
            return localVarFp.getPartnerById(requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get partner by name
         * @summary Get partner by name
         * @param {PartnersApiGetPartnerByNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerByName(requestParameters, options) {
            return localVarFp.getPartnerByName(requestParameters.partnerName, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
export class PartnersApi extends BaseAPI {
    /**
     * Create a partner
     * @summary Create a partner
     * @param {PartnersApiCreatePartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createPartner(requestParameters, options) {
        return PartnersApiFp(this.configuration).createPartner(requestParameters.createPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all partners
     * @summary Get all partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getAllPartners(options) {
        return PartnersApiFp(this.configuration).getAllPartners(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get partner by id
     * @summary Get partner by id
     * @param {PartnersApiGetPartnerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getPartnerById(requestParameters, options) {
        return PartnersApiFp(this.configuration).getPartnerById(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get partner by name
     * @summary Get partner by name
     * @param {PartnersApiGetPartnerByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getPartnerByName(requestParameters, options) {
        return PartnersApiFp(this.configuration).getPartnerByName(requestParameters.partnerName, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ScheduleApi - axios parameter creator
 * @export
 */
export const ScheduleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary retrieves schedule logs by brandId
         * @param {string} brandId Brand id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByBrand: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getLogsByBrand', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/sync`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary retrieves schedule logs by integrationId
         * @param {string} brandId Brand id
         * @param {string} integrationId Integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByIntegration: (brandId, integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getLogsByIntegration', 'brandId', brandId);
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getLogsByIntegration', 'integrationId', integrationId);
            const localVarPath = `/brand/{brandId}/integration/{integrationId}/sync`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary retrieves schedule logs by integrationId
         * @param {string} integrationId Integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByIntegrationId: (integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('getLogsByIntegrationId', 'integrationId', integrationId);
            const localVarPath = `/integration/{integrationId}/sync`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary schedule Facebook data sync
         * @param {string} brandId the id of the brand
         * @param {string} integrationId the id of the integration
         * @param {ScheduleSyncInput} scheduleSyncInput parameters required to schedule sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSync: (brandId, integrationId, scheduleSyncInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('scheduleSync', 'brandId', brandId);
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('scheduleSync', 'integrationId', integrationId);
            // verify required parameter 'scheduleSyncInput' is not null or undefined
            assertParamExists('scheduleSync', 'scheduleSyncInput', scheduleSyncInput);
            const localVarPath = `/brand/{brandId}/integration/{integrationId}/sync`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleSyncInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary schedule sync for all type of integration
         * @param {string} integrationId the id of the integration
         * @param {ScheduleSyncInput} scheduleSyncInput parameters required to schedule sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSyncTask: (integrationId, scheduleSyncInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            assertParamExists('scheduleSyncTask', 'integrationId', integrationId);
            // verify required parameter 'scheduleSyncInput' is not null or undefined
            assertParamExists('scheduleSyncTask', 'scheduleSyncInput', scheduleSyncInput);
            const localVarPath = `/integration/{integrationId}/sync`
                .replace(`{${"integrationId"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleSyncInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ScheduleApi - functional programming interface
 * @export
 */
export const ScheduleApiFp = function (configuration) {
    const localVarAxiosParamCreator = ScheduleApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary retrieves schedule logs by brandId
         * @param {string} brandId Brand id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByBrand(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLogsByBrand(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ScheduleApi.getLogsByBrand']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary retrieves schedule logs by integrationId
         * @param {string} brandId Brand id
         * @param {string} integrationId Integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByIntegration(brandId, integrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLogsByIntegration(brandId, integrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ScheduleApi.getLogsByIntegration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary retrieves schedule logs by integrationId
         * @param {string} integrationId Integration id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByIntegrationId(integrationId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLogsByIntegrationId(integrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ScheduleApi.getLogsByIntegrationId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary schedule Facebook data sync
         * @param {string} brandId the id of the brand
         * @param {string} integrationId the id of the integration
         * @param {ScheduleSyncInput} scheduleSyncInput parameters required to schedule sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSync(brandId, integrationId, scheduleSyncInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduleSync(brandId, integrationId, scheduleSyncInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ScheduleApi.scheduleSync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary schedule sync for all type of integration
         * @param {string} integrationId the id of the integration
         * @param {ScheduleSyncInput} scheduleSyncInput parameters required to schedule sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSyncTask(integrationId, scheduleSyncInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduleSyncTask(integrationId, scheduleSyncInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ScheduleApi.scheduleSyncTask']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ScheduleApi - factory interface
 * @export
 */
export const ScheduleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ScheduleApiFp(configuration);
    return {
        /**
         *
         * @summary retrieves schedule logs by brandId
         * @param {ScheduleApiGetLogsByBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByBrand(requestParameters, options) {
            return localVarFp.getLogsByBrand(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary retrieves schedule logs by integrationId
         * @param {ScheduleApiGetLogsByIntegrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByIntegration(requestParameters, options) {
            return localVarFp.getLogsByIntegration(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary retrieves schedule logs by integrationId
         * @param {ScheduleApiGetLogsByIntegrationIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsByIntegrationId(requestParameters, options) {
            return localVarFp.getLogsByIntegrationId(requestParameters.integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary schedule Facebook data sync
         * @param {ScheduleApiScheduleSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSync(requestParameters, options) {
            return localVarFp.scheduleSync(requestParameters.brandId, requestParameters.integrationId, requestParameters.scheduleSyncInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary schedule sync for all type of integration
         * @param {ScheduleApiScheduleSyncTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleSyncTask(requestParameters, options) {
            return localVarFp.scheduleSyncTask(requestParameters.integrationId, requestParameters.scheduleSyncInput, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ScheduleApi - object-oriented interface
 * @export
 * @class ScheduleApi
 * @extends {BaseAPI}
 */
export class ScheduleApi extends BaseAPI {
    /**
     *
     * @summary retrieves schedule logs by brandId
     * @param {ScheduleApiGetLogsByBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    getLogsByBrand(requestParameters, options) {
        return ScheduleApiFp(this.configuration).getLogsByBrand(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary retrieves schedule logs by integrationId
     * @param {ScheduleApiGetLogsByIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    getLogsByIntegration(requestParameters, options) {
        return ScheduleApiFp(this.configuration).getLogsByIntegration(requestParameters.brandId, requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary retrieves schedule logs by integrationId
     * @param {ScheduleApiGetLogsByIntegrationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    getLogsByIntegrationId(requestParameters, options) {
        return ScheduleApiFp(this.configuration).getLogsByIntegrationId(requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary schedule Facebook data sync
     * @param {ScheduleApiScheduleSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    scheduleSync(requestParameters, options) {
        return ScheduleApiFp(this.configuration).scheduleSync(requestParameters.brandId, requestParameters.integrationId, requestParameters.scheduleSyncInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary schedule sync for all type of integration
     * @param {ScheduleApiScheduleSyncTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    scheduleSyncTask(requestParameters, options) {
        return ScheduleApiFp(this.configuration).scheduleSyncTask(requestParameters.integrationId, requestParameters.scheduleSyncInput, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ShopifyIntegrationApi - axios parameter creator
 * @export
 */
export const ShopifyIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary generates an access token and publishes an event to save that token
         * @param {string} brandId Brand id
         * @param {CreateAccessToken} createAccessToken parameters required to create an access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken: (brandId, createAccessToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createAccessToken', 'brandId', brandId);
            // verify required parameter 'createAccessToken' is not null or undefined
            assertParamExists('createAccessToken', 'createAccessToken', createAccessToken);
            const localVarPath = `/brand/{brandId}/integration/shopify`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createAccessToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary generates an oauth url for the shopify shop
         * @param {GenerateOAuthUrl} generateOAuthUrl parameters required to generate oauth url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrl1: (generateOAuthUrl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateOAuthUrl' is not null or undefined
            assertParamExists('generateOAuthUrl1', 'generateOAuthUrl', generateOAuthUrl);
            const localVarPath = `/integration/shopify/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateOAuthUrl, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary generates an oauth url from an app install via the shopify app store
         * @param {GenerateOAuthUrlWithValidation} generateOAuthUrlWithValidation parameters required to generate oauth url with validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrlWithValidation: (generateOAuthUrlWithValidation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateOAuthUrlWithValidation' is not null or undefined
            assertParamExists('generateOAuthUrlWithValidation', 'generateOAuthUrlWithValidation', generateOAuthUrlWithValidation);
            const localVarPath = `/integration/shopify/auth-with-validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateOAuthUrlWithValidation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary retrieves integration data matching by Shopify shop
         * @param {string} [storeUrl] Valid store URL to retrieve the store from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStore: (storeUrl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/integration/shopify/store`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (storeUrl !== undefined) {
                localVarQueryParameter['storeUrl'] = storeUrl;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ShopifyIntegrationApi - functional programming interface
 * @export
 */
export const ShopifyIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShopifyIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary generates an access token and publishes an event to save that token
         * @param {string} brandId Brand id
         * @param {CreateAccessToken} createAccessToken parameters required to create an access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(brandId, createAccessToken, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccessToken(brandId, createAccessToken, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ShopifyIntegrationApi.createAccessToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary generates an oauth url for the shopify shop
         * @param {GenerateOAuthUrl} generateOAuthUrl parameters required to generate oauth url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrl1(generateOAuthUrl, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateOAuthUrl1(generateOAuthUrl, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ShopifyIntegrationApi.generateOAuthUrl1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary generates an oauth url from an app install via the shopify app store
         * @param {GenerateOAuthUrlWithValidation} generateOAuthUrlWithValidation parameters required to generate oauth url with validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrlWithValidation(generateOAuthUrlWithValidation, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateOAuthUrlWithValidation(generateOAuthUrlWithValidation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ShopifyIntegrationApi.generateOAuthUrlWithValidation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary retrieves integration data matching by Shopify shop
         * @param {string} [storeUrl] Valid store URL to retrieve the store from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStore(storeUrl, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStore(storeUrl, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ShopifyIntegrationApi.getStore']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ShopifyIntegrationApi - factory interface
 * @export
 */
export const ShopifyIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShopifyIntegrationApiFp(configuration);
    return {
        /**
         *
         * @summary generates an access token and publishes an event to save that token
         * @param {ShopifyIntegrationApiCreateAccessTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccessToken(requestParameters, options) {
            return localVarFp.createAccessToken(requestParameters.brandId, requestParameters.createAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary generates an oauth url for the shopify shop
         * @param {ShopifyIntegrationApiGenerateOAuthUrl1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrl1(requestParameters, options) {
            return localVarFp.generateOAuthUrl1(requestParameters.generateOAuthUrl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary generates an oauth url from an app install via the shopify app store
         * @param {ShopifyIntegrationApiGenerateOAuthUrlWithValidationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrlWithValidation(requestParameters, options) {
            return localVarFp.generateOAuthUrlWithValidation(requestParameters.generateOAuthUrlWithValidation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary retrieves integration data matching by Shopify shop
         * @param {ShopifyIntegrationApiGetStoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStore(requestParameters = {}, options) {
            return localVarFp.getStore(requestParameters.storeUrl, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShopifyIntegrationApi - object-oriented interface
 * @export
 * @class ShopifyIntegrationApi
 * @extends {BaseAPI}
 */
export class ShopifyIntegrationApi extends BaseAPI {
    /**
     *
     * @summary generates an access token and publishes an event to save that token
     * @param {ShopifyIntegrationApiCreateAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyIntegrationApi
     */
    createAccessToken(requestParameters, options) {
        return ShopifyIntegrationApiFp(this.configuration).createAccessToken(requestParameters.brandId, requestParameters.createAccessToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary generates an oauth url for the shopify shop
     * @param {ShopifyIntegrationApiGenerateOAuthUrl1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyIntegrationApi
     */
    generateOAuthUrl1(requestParameters, options) {
        return ShopifyIntegrationApiFp(this.configuration).generateOAuthUrl1(requestParameters.generateOAuthUrl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary generates an oauth url from an app install via the shopify app store
     * @param {ShopifyIntegrationApiGenerateOAuthUrlWithValidationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyIntegrationApi
     */
    generateOAuthUrlWithValidation(requestParameters, options) {
        return ShopifyIntegrationApiFp(this.configuration).generateOAuthUrlWithValidation(requestParameters.generateOAuthUrlWithValidation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary retrieves integration data matching by Shopify shop
     * @param {ShopifyIntegrationApiGetStoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyIntegrationApi
     */
    getStore(requestParameters = {}, options) {
        return ShopifyIntegrationApiFp(this.configuration).getStore(requestParameters.storeUrl, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TiktokIntegrationApi - axios parameter creator
 * @export
 */
export const TiktokIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a TikTok integration for a brand
         * @param {string} brandId The brand ID
         * @param {CreateIntegrationInput} createIntegrationInput Parameters required to create the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegration1: (brandId, createIntegrationInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createIntegration1', 'brandId', brandId);
            // verify required parameter 'createIntegrationInput' is not null or undefined
            assertParamExists('createIntegration1', 'createIntegrationInput', createIntegrationInput);
            const localVarPath = `/brand/{brandId}/integration/tiktok`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createIntegrationInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generate TikTok OAuth URL
         * @param {GenerateOAuthUrlRequest} generateOAuthUrlRequest parameters required to generate oauth url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrl: (generateOAuthUrlRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateOAuthUrlRequest' is not null or undefined
            assertParamExists('generateOAuthUrl', 'generateOAuthUrlRequest', generateOAuthUrlRequest);
            const localVarPath = `/integration/tiktok/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateOAuthUrlRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets an active ad account id and its integration id
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTiktokAdAccount: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getCurrentTiktokAdAccount', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/tiktok/adAccount/current`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary gets ad accounts for brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiktokAdAccounts: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getTiktokAdAccounts', 'brandId', brandId);
            const localVarPath = `/brand/{brandId}/tiktok/adAccount`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get all ad accounts from brandId list
         * @param {string} brandId the brand ids to batch ad accounts for, separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiktokAdAccountsBatch: (brandId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getTiktokAdAccountsBatch', 'brandId', brandId);
            const localVarPath = `/integration/tiktok/adAccount/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary set the current tiktok ad account id for brand
         * @param {string} brandId the brandId of the user
         * @param {string} adAccountId the ad account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdAccount1: (brandId, adAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateAdAccount1', 'brandId', brandId);
            // verify required parameter 'adAccountId' is not null or undefined
            assertParamExists('updateAdAccount1', 'adAccountId', adAccountId);
            const localVarPath = `/brand/{brandId}/tiktok/adAccount/{adAccountId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"adAccountId"}}`, encodeURIComponent(String(adAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TiktokIntegrationApi - functional programming interface
 * @export
 */
export const TiktokIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = TiktokIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a TikTok integration for a brand
         * @param {string} brandId The brand ID
         * @param {CreateIntegrationInput} createIntegrationInput Parameters required to create the integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegration1(brandId, createIntegrationInput, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createIntegration1(brandId, createIntegrationInput, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TiktokIntegrationApi.createIntegration1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Generate TikTok OAuth URL
         * @param {GenerateOAuthUrlRequest} generateOAuthUrlRequest parameters required to generate oauth url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrl(generateOAuthUrlRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateOAuthUrl(generateOAuthUrlRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TiktokIntegrationApi.generateOAuthUrl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets an active ad account id and its integration id
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTiktokAdAccount(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentTiktokAdAccount(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TiktokIntegrationApi.getCurrentTiktokAdAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary gets ad accounts for brand
         * @param {string} brandId the id of the brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiktokAdAccounts(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTiktokAdAccounts(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TiktokIntegrationApi.getTiktokAdAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary get all ad accounts from brandId list
         * @param {string} brandId the brand ids to batch ad accounts for, separated by comma
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiktokAdAccountsBatch(brandId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTiktokAdAccountsBatch(brandId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TiktokIntegrationApi.getTiktokAdAccountsBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary set the current tiktok ad account id for brand
         * @param {string} brandId the brandId of the user
         * @param {string} adAccountId the ad account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdAccount1(brandId, adAccountId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAdAccount1(brandId, adAccountId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TiktokIntegrationApi.updateAdAccount1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * TiktokIntegrationApi - factory interface
 * @export
 */
export const TiktokIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TiktokIntegrationApiFp(configuration);
    return {
        /**
         *
         * @summary Create a TikTok integration for a brand
         * @param {TiktokIntegrationApiCreateIntegration1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegration1(requestParameters, options) {
            return localVarFp.createIntegration1(requestParameters.brandId, requestParameters.createIntegrationInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate TikTok OAuth URL
         * @param {TiktokIntegrationApiGenerateOAuthUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOAuthUrl(requestParameters, options) {
            return localVarFp.generateOAuthUrl(requestParameters.generateOAuthUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets an active ad account id and its integration id
         * @param {TiktokIntegrationApiGetCurrentTiktokAdAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTiktokAdAccount(requestParameters, options) {
            return localVarFp.getCurrentTiktokAdAccount(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary gets ad accounts for brand
         * @param {TiktokIntegrationApiGetTiktokAdAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiktokAdAccounts(requestParameters, options) {
            return localVarFp.getTiktokAdAccounts(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get all ad accounts from brandId list
         * @param {TiktokIntegrationApiGetTiktokAdAccountsBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTiktokAdAccountsBatch(requestParameters, options) {
            return localVarFp.getTiktokAdAccountsBatch(requestParameters.brandId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary set the current tiktok ad account id for brand
         * @param {TiktokIntegrationApiUpdateAdAccount1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdAccount1(requestParameters, options) {
            return localVarFp.updateAdAccount1(requestParameters.brandId, requestParameters.adAccountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TiktokIntegrationApi - object-oriented interface
 * @export
 * @class TiktokIntegrationApi
 * @extends {BaseAPI}
 */
export class TiktokIntegrationApi extends BaseAPI {
    /**
     *
     * @summary Create a TikTok integration for a brand
     * @param {TiktokIntegrationApiCreateIntegration1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiktokIntegrationApi
     */
    createIntegration1(requestParameters, options) {
        return TiktokIntegrationApiFp(this.configuration).createIntegration1(requestParameters.brandId, requestParameters.createIntegrationInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generate TikTok OAuth URL
     * @param {TiktokIntegrationApiGenerateOAuthUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiktokIntegrationApi
     */
    generateOAuthUrl(requestParameters, options) {
        return TiktokIntegrationApiFp(this.configuration).generateOAuthUrl(requestParameters.generateOAuthUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets an active ad account id and its integration id
     * @param {TiktokIntegrationApiGetCurrentTiktokAdAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiktokIntegrationApi
     */
    getCurrentTiktokAdAccount(requestParameters, options) {
        return TiktokIntegrationApiFp(this.configuration).getCurrentTiktokAdAccount(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary gets ad accounts for brand
     * @param {TiktokIntegrationApiGetTiktokAdAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiktokIntegrationApi
     */
    getTiktokAdAccounts(requestParameters, options) {
        return TiktokIntegrationApiFp(this.configuration).getTiktokAdAccounts(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get all ad accounts from brandId list
     * @param {TiktokIntegrationApiGetTiktokAdAccountsBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiktokIntegrationApi
     */
    getTiktokAdAccountsBatch(requestParameters, options) {
        return TiktokIntegrationApiFp(this.configuration).getTiktokAdAccountsBatch(requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary set the current tiktok ad account id for brand
     * @param {TiktokIntegrationApiUpdateAdAccount1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TiktokIntegrationApi
     */
    updateAdAccount1(requestParameters, options) {
        return TiktokIntegrationApiFp(this.configuration).updateAdAccount1(requestParameters.brandId, requestParameters.adAccountId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add a favorite
         * @summary Add a favorite
         * @param {string} userId id of user
         * @param {UserFavoriteRequest} userFavoriteRequest Favorites to add to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite: (userId, userFavoriteRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addFavorite', 'userId', userId);
            // verify required parameter 'userFavoriteRequest' is not null or undefined
            assertParamExists('addFavorite', 'userFavoriteRequest', userFavoriteRequest);
            const localVarPath = `/user/{userId}/favorite`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userFavoriteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a favorite
         * @summary Delete a favorite from the user
         * @param {string} userId id of user
         * @param {UserFavoriteRequest} userFavoriteRequest Favorite to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavorite: (userId, userFavoriteRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteFavorite', 'userId', userId);
            // verify required parameter 'userFavoriteRequest' is not null or undefined
            assertParamExists('deleteFavorite', 'userFavoriteRequest', userFavoriteRequest);
            const localVarPath = `/user/{userId}/favorite`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userFavoriteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all brands for a given user
         * @param {string} userId id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandsForUser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAllBrandsForUser', 'userId', userId);
            const localVarPath = `/user/{userId}/brand`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all associated brands for every user from given ids
         * @param {string} userId comma delimited list of userIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandsForUserBatch: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAllBrandsForUserBatch', 'userId', userId);
            const localVarPath = `/user/brand/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get brand history
         * @summary Get history of last 5 brands per user
         * @param {string} userId user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandHistory: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBrandHistory', 'userId', userId);
            const localVarPath = `/user/{userId}/brand/history`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all favorites
         * @summary Retrieve all favorites for a user
         * @param {string} userId id of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getFavorites', 'userId', userId);
            const localVarPath = `/user/{userId}/favorite`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * retrieves profile for user
         * @param {string} userId id of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProfile', 'userId', userId);
            const localVarPath = `/user/{userId}/profile`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * retrieves a batch of profiles
         * @param {string} userId comma delimited list of userIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileBatch: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProfileBatch', 'userId', userId);
            const localVarPath = `/profile/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * retrieves a batch of pii profiles
         * @param {string} userId comma delimited list of userIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileBatchPii: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProfileBatchPii', 'userId', userId);
            const localVarPath = `/profile/batch/pii`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * update a user profile
         * @param {string} userId id of user
         * @param {UpdateProfileRequest} updateProfileRequest user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: (userId, updateProfileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProfile', 'userId', userId);
            // verify required parameter 'updateProfileRequest' is not null or undefined
            assertParamExists('updateProfile', 'updateProfileRequest', updateProfileRequest);
            const localVarPath = `/user/{userId}/profile`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Token required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * Add a favorite
         * @summary Add a favorite
         * @param {string} userId id of user
         * @param {UserFavoriteRequest} userFavoriteRequest Favorites to add to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite(userId, userFavoriteRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addFavorite(userId, userFavoriteRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.addFavorite']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Delete a favorite
         * @summary Delete a favorite from the user
         * @param {string} userId id of user
         * @param {UserFavoriteRequest} userFavoriteRequest Favorite to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavorite(userId, userFavoriteRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFavorite(userId, userFavoriteRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.deleteFavorite']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all brands for a given user
         * @param {string} userId id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandsForUser(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBrandsForUser(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getAllBrandsForUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Gets all associated brands for every user from given ids
         * @param {string} userId comma delimited list of userIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandsForUserBatch(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBrandsForUserBatch(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getAllBrandsForUserBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get brand history
         * @summary Get history of last 5 brands per user
         * @param {string} userId user id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandHistory(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBrandHistory(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getBrandHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all favorites
         * @summary Retrieve all favorites for a user
         * @param {string} userId id of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFavorites(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getFavorites']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * retrieves profile for user
         * @param {string} userId id of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProfile(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getProfile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * retrieves a batch of profiles
         * @param {string} userId comma delimited list of userIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileBatch(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProfileBatch(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getProfileBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * retrieves a batch of pii profiles
         * @param {string} userId comma delimited list of userIds in batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileBatchPii(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProfileBatchPii(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.getProfileBatchPii']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * update a user profile
         * @param {string} userId id of user
         * @param {UpdateProfileRequest} updateProfileRequest user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(userId, updateProfileRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateProfile(userId, updateProfileRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UsersApi.updateProfile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         * Add a favorite
         * @summary Add a favorite
         * @param {UsersApiAddFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavorite(requestParameters, options) {
            return localVarFp.addFavorite(requestParameters.userId, requestParameters.userFavoriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a favorite
         * @summary Delete a favorite from the user
         * @param {UsersApiDeleteFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavorite(requestParameters, options) {
            return localVarFp.deleteFavorite(requestParameters.userId, requestParameters.userFavoriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all brands for a given user
         * @param {UsersApiGetAllBrandsForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandsForUser(requestParameters, options) {
            return localVarFp.getAllBrandsForUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all associated brands for every user from given ids
         * @param {UsersApiGetAllBrandsForUserBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBrandsForUserBatch(requestParameters, options) {
            return localVarFp.getAllBrandsForUserBatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand history
         * @summary Get history of last 5 brands per user
         * @param {UsersApiGetBrandHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandHistory(requestParameters, options) {
            return localVarFp.getBrandHistory(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all favorites
         * @summary Retrieve all favorites for a user
         * @param {UsersApiGetFavoritesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(requestParameters, options) {
            return localVarFp.getFavorites(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves profile for user
         * @param {UsersApiGetProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(requestParameters, options) {
            return localVarFp.getProfile(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves a batch of profiles
         * @param {UsersApiGetProfileBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileBatch(requestParameters, options) {
            return localVarFp.getProfileBatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves a batch of pii profiles
         * @param {UsersApiGetProfileBatchPiiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileBatchPii(requestParameters, options) {
            return localVarFp.getProfileBatchPii(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * update a user profile
         * @param {UsersApiUpdateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(requestParameters, options) {
            return localVarFp.updateProfile(requestParameters.userId, requestParameters.updateProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Add a favorite
     * @summary Add a favorite
     * @param {UsersApiAddFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    addFavorite(requestParameters, options) {
        return UsersApiFp(this.configuration).addFavorite(requestParameters.userId, requestParameters.userFavoriteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a favorite
     * @summary Delete a favorite from the user
     * @param {UsersApiDeleteFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteFavorite(requestParameters, options) {
        return UsersApiFp(this.configuration).deleteFavorite(requestParameters.userId, requestParameters.userFavoriteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all brands for a given user
     * @param {UsersApiGetAllBrandsForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAllBrandsForUser(requestParameters, options) {
        return UsersApiFp(this.configuration).getAllBrandsForUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all associated brands for every user from given ids
     * @param {UsersApiGetAllBrandsForUserBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getAllBrandsForUserBatch(requestParameters, options) {
        return UsersApiFp(this.configuration).getAllBrandsForUserBatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get brand history
     * @summary Get history of last 5 brands per user
     * @param {UsersApiGetBrandHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getBrandHistory(requestParameters, options) {
        return UsersApiFp(this.configuration).getBrandHistory(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all favorites
     * @summary Retrieve all favorites for a user
     * @param {UsersApiGetFavoritesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getFavorites(requestParameters, options) {
        return UsersApiFp(this.configuration).getFavorites(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * retrieves profile for user
     * @param {UsersApiGetProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getProfile(requestParameters, options) {
        return UsersApiFp(this.configuration).getProfile(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * retrieves a batch of profiles
     * @param {UsersApiGetProfileBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getProfileBatch(requestParameters, options) {
        return UsersApiFp(this.configuration).getProfileBatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * retrieves a batch of pii profiles
     * @param {UsersApiGetProfileBatchPiiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getProfileBatchPii(requestParameters, options) {
        return UsersApiFp(this.configuration).getProfileBatchPii(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * update a user profile
     * @param {UsersApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    updateProfile(requestParameters, options) {
        return UsersApiFp(this.configuration).updateProfile(requestParameters.userId, requestParameters.updateProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
